(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var ref;

if (typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.Performance) != null ? ref.pageReady : void 0 : void 0) {
  Groupon.Performance.pageReady();
}

require('../../modules/optimize_config/frontend/optimize_config');

require('../../modules/ad_inventory_for_gsm/frontend/ad_inventory_dfp');

require('../../modules/deals/frontend/toggle');

require('../../modules/seo-platform-editorial/frontend/editorial_widget');

require('../../modules/deals/frontend/update');

require('../../modules/helpers/frontend/html');

$(document).ready(function() {
  return Groupon.ui.GSMEditorialWidget.initWidget();
});



},{"../../modules/ad_inventory_for_gsm/frontend/ad_inventory_dfp":2,"../../modules/deals/frontend/toggle":5,"../../modules/deals/frontend/update":6,"../../modules/helpers/frontend/html":7,"../../modules/optimize_config/frontend/optimize_config":10,"../../modules/seo-platform-editorial/frontend/editorial_widget":11}],2:[function(require,module,exports){
var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];

var adscript = function() {
  try {
    (function() {
      var gads = document.createElement('script');
      gads.async = true;
      gads.type = 'text/javascript';
      var useSSL = 'https:' == document.location.protocol;
      gads.src = (useSSL ? 'https:' : 'http:') + 
      '//www.googletagservices.com/tag/js/gpt.js';
      var node = document.getElementsByTagName('script')[0];
      node.parentNode.insertBefore(gads, node);
    })();

    googletag.cmd.push(function() {
    // googletag.defineSlot('/99819337/production/groupon.com/seo/seo_local', [[160, 600]], 'div-gpt-ad-1425070317256-0').addService(googletag.pubads());
    googletag.defineSlot('/99819337/production/groupon.com/seo/seo_local/728x90BTF', [728, 90], 'div-gpt-ad-1439925085884-0').addService(googletag.pubads());
    googletag.defineSlot('/99819337/production/groupon.com/seo/seo_local/728x90Carousel1', [728, 90], 'div-gpt-ad-1439924840199-0').addService(googletag.pubads());
    googletag.defineSlot('/99819337/production/groupon.com/seo/seo_local/728x90Carousel2', [728, 90], 'div-gpt-ad-1439924932272-0').addService(googletag.pubads());
    googletag.defineSlot('/99819337/production/groupon.com/seo/seo_local/728x90Carousel3', [728, 90], 'div-gpt-ad-1439925004801-0').addService(googletag.pubads());

    googletag.defineSlot('/99819337/production/Touch/SEO', [[300, 50]], 'div-gpt-ad-1437413051854-0').addService(googletag.pubads());
    googletag.defineSlot('/99819337/production/Touch/SEO', [[300, 250]], 'div-gpt-ad-1437413051854-1').addService(googletag.pubads());
    
    googletag.pubads().enableSingleRequest();
    googletag.enableServices();
    });
  }
  catch(ex){
    // do nothing  
  }
};

Finch && Finch.experiment("GSMDesktopInFlowAdsExperiment", { show: adscript });
Finch && Finch.experiment("GSMTouchAdsExperiment", { show: adscript });

},{}],3:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.d("dealGrid.length",c,p,1),c,p,0,20,1567,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<div class=\"deal-space ");t.b(t.v(t.f("dealSpaceLayout",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <div class=\"block-grid ");t.b(t.v(t.f("gridLayout",c,p,0)));t.b(" deal-grid");if(t.s(t.f("allowGridToggle",c,p,1),c,p,0,135,148,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" allow-toggle");});c.pop();}t.b("\" data-bhw=\"GsmCategoryDealsContainer\">");t.b("\n" + i);if(t.s(t.f("dealGrid",c,p,1),c,p,0,225,1537,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <figure class=\"deal-card deal-list-tile deal-tile deal-tile-standard\" data-bhc=\"deal:");t.b(t.v(t.f("uuid",c,p,0)));t.b("\" data-bhd=\"");t.b(t.v(t.f("bloodHoundString",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b("      <a href=\"");t.b(t.v(t.f("dealUrl",c,p,0)));t.b("\" class=\"deal-tile-inner\">");t.b("\n" + i);t.b("        <img src=\"");t.b(t.v(t.f("grid4ImageUrl",c,p,0)));t.b("\"/>");t.b("\n" + i);t.b("        <figcaption>");t.b("\n" + i);t.b("          <div class=\"deal-tile-content\">");t.b("\n" + i);t.b("            <p class=\"deal-title should-truncate\">");t.b(t.t(t.f("title",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("            <p class=\"merchant-name should-truncate\">");t.b(t.t(t.d("merchant.name",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("            <p class=\"deal-location should-truncate\">");t.b(t.v(t.f("redemptionLocation",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("            <div class=\"description should-truncate deal-tile-description hide show-in-list-view\">");t.b(t.t(t.f("writeup",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("          <div class=\"purchase-info\">");t.b("\n" + i);t.b("            <p class=\"deal-price\">");t.b("\n" + i);t.b("              <s class=\"original-price\">");t.b(t.v(t.d("priceSummary.value.formattedAmount",c,p,0)));t.b("</s>");t.b("\n" + i);t.b("              <s class=\"discount-price c-txt-price\">");t.b(t.v(t.d("priceSummary.price.formattedAmount",c,p,0)));t.b("</s>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);t.b("            <div class=\"hide show-in-list-view\">");t.b("\n" + i);t.b("              <p class=\"deal-tile-actions\">");t.b("\n" + i);t.b("                <span class=\"btn-buy btn-small\" data-bhw=\"ViewDealButton\">");t.b("\n" + i);t.b("                  ");if(t.s(t.f("translate",c,p,1),c,p,0,1366,1392,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.deals.view_deal");});c.pop();}t.b("\n" + i);t.b("                </span>");t.b("\n" + i);t.b("              </p>");t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </figcaption>");t.b("\n" + i);t.b("      </a>");t.b("\n" + i);t.b("    </figure>");t.b("\n" + i);});c.pop();}t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#dealGrid.length}}\n<div class=\"deal-space {{dealSpaceLayout}}\">\n  <div class=\"block-grid {{gridLayout}} deal-grid{{#allowGridToggle}} allow-toggle{{/allowGridToggle}}\" data-bhw=\"GsmCategoryDealsContainer\">\n    {{#dealGrid}}\n    <figure class=\"deal-card deal-list-tile deal-tile deal-tile-standard\" data-bhc=\"deal:{{uuid}}\" data-bhd=\"{{bloodHoundString}}\" data-bh-viewport=\"respect\">\n      <a href=\"{{dealUrl}}\" class=\"deal-tile-inner\">\n        <img src=\"{{grid4ImageUrl}}\"/>\n        <figcaption>\n          <div class=\"deal-tile-content\">\n            <p class=\"deal-title should-truncate\">{{{title}}}</p>\n            <p class=\"merchant-name should-truncate\">{{{merchant.name}}}</p>\n            <p class=\"deal-location should-truncate\">{{redemptionLocation}}</p>\n            <div class=\"description should-truncate deal-tile-description hide show-in-list-view\">{{{writeup}}}</div>\n          </div>\n          <div class=\"purchase-info\">\n            <p class=\"deal-price\">\n              <s class=\"original-price\">{{priceSummary.value.formattedAmount}}</s>\n              <s class=\"discount-price c-txt-price\">{{priceSummary.price.formattedAmount}}</s>\n            </p>\n            <div class=\"hide show-in-list-view\">\n              <p class=\"deal-tile-actions\">\n                <span class=\"btn-buy btn-small\" data-bhw=\"ViewDealButton\">\n                  {{#translate}}js.modules.deals.view_deal{{/translate}}\n                </span>\n              </p>\n            </div>\n          </div>\n        </figcaption>\n      </a>\n    </figure>\n    {{/dealGrid}}\n  </div>\n</div>\n{{/dealGrid.length}}\n", Hogan);
},{"hogan.js":13}],4:[function(require,module,exports){
(function (global){
var GrouponGsmDeals, MAX_DEALS, PRICE_REGEX, VALUE_REGEX, closestTo, createSnippet, currencySymbol, distance, filter, formatIsoTime, formatTime, getGridLayout, interpolatePricing, map, min, numbersEqual, reduce, ref, ref1, reject, some, stripHtml, writeupFor;

ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), map = ref.map, reject = ref.reject, reduce = ref.reduce, filter = ref.filter, min = ref.min, some = ref.some;

ref1 = require('../../helpers/html'), stripHtml = ref1.stripHtml, createSnippet = ref1.createSnippet;


/*
Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
© 2011 Colin Snover <http://zetafleet.com>
Released under MIT license.
 */

(function(Date, undefined_) {
  var numericKeys, origParse;
  origParse = Date.parse;
  numericKeys = [1, 4, 5, 6, 7, 10, 11];
  return Date.parse = function(date) {
    var i, k, minutesOffset, struct, timestamp;
    timestamp = void 0;
    struct = void 0;
    minutesOffset = 0;
    if (struct = /^(\d{4}|[+\-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+\-])(\d{2})(?::(\d{2}))?)?)?$/.exec(date)) {
      i = 0;
      k = void 0;
      while ((k = numericKeys[i])) {
        struct[k] = +struct[k] || 0;
        ++i;
      }
      struct[2] = (+struct[2] || 1) - 1;
      struct[3] = +struct[3] || 1;
      if (struct[8] !== "Z" && struct[9] !== void 0) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === "+") {
          minutesOffset = 0 - minutesOffset;
        }
      }
      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    } else {
      timestamp = (origParse ? origParse(date) : 0/0);
    }
    return timestamp;
  };
})(Date);

currencySymbol = function(currencyCode) {
  switch (currencyCode) {
    case 'USD':
      return '$';
    case 'CAD':
      return 'C$';
    case 'GBP':
      return '£';
    default:
      return '$';
  }
};

formatTime = function(timeStr) {
  var ampm, formatted, hours, i, minutes, ref2, seconds;
  ref2 = (function() {
    var j, len, ref2, results;
    ref2 = timeStr.split(':');
    results = [];
    for (j = 0, len = ref2.length; j < len; j++) {
      i = ref2[j];
      results.push(parseInt(i));
    }
    return results;
  })(), hours = ref2[0], minutes = ref2[1], seconds = ref2[2];
  ampm = 'am';
  if (hours >= 12) {
    ampm = 'pm';
    if (hours > 12) {
      hours -= 12;
    }
  }
  if (hours === 0) {
    hours = 12;
  }
  formatted = '';
  formatted += hours;
  formatted += ':';
  if (minutes < 10) {
    formatted += '0';
  }
  formatted += minutes;
  formatted += ampm;
  return formatted;
};

formatIsoTime = function(timeStr, dealTzOffset) {
  var d, dateObj, serverTzOffset;
  d = new Date();
  serverTzOffset = -d.getTimezoneOffset() * 60 * 1000;
  dateObj = new Date(Date.parse(timeStr) - (serverTzOffset - dealTzOffset));
  return formatTime('' + dateObj.getHours() + ':' + dateObj.getMinutes() + ':' + dateObj.getSeconds());
};

writeupFor = function(deal, keyword) {
  var snippet, text;
  text = deal.highlightsHtml;
  snippet = createSnippet(text, keyword, ['a', 'img']);
  if (snippet === null) {
    text = deal.pitchHtml;
    snippet = createSnippet(text, keyword);
  }
  if (snippet === null) {
    text = deal.highlightsHtml;
    snippet = stripHtml(text, ['a', 'img']);
  }
  return snippet;
};

PRICE_REGEX = /\${[^}]+unit_price}/g;

VALUE_REGEX = /\${[^}]+unit_value}/g;

interpolatePricing = function(str, price, value) {
  if (str == null) {
    return null;
  }
  return str.replace(PRICE_REGEX, price.formattedAmount).replace(VALUE_REGEX, value.formattedAmount);
};

MAX_DEALS = 80;

getGridLayout = function(opts) {
  var result;
  result = {
    gridLayout: 'three-up',
    toggle_state: 'grid',
    has_lh_nav: !!(opts != null ? opts.hasLhNav : void 0)
  };
  if (!!(opts != null ? opts.hasLhNav : void 0)) {
    result.gridLayout = 'two-up';
  }
  if (opts != null ? opts.forceLayoutType : void 0) {
    result.gridLayout = opts.forceLayoutType;
  }
  if (opts != null ? opts.forceGridView : void 0) {
    result.toggle_state = 'grid';
  } else if (opts != null ? opts.hasMaps : void 0) {
    result.toggle_state = 'maps';
  } else {
    result.toggle_state = 'list';
  }
  return result;
};

distance = function(lat1, lon1, lat2, lon2, unit) {
  var dist, radlat1, radlat2, radlon1, radlon2, radtheta, theta;
  radlat1 = Math.PI * lat1 / 180;
  radlat2 = Math.PI * lat2 / 180;
  radlon1 = Math.PI * lon1 / 180;
  radlon2 = Math.PI * lon2 / 180;
  theta = lon1 - lon2;
  radtheta = Math.PI * theta / 180;
  dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist);
  dist = dist * 180 / Math.PI;
  dist = dist * 60 * 1.1515;
  if (unit === "K") {
    dist = dist * 1.609344;
  }
  if (unit === "N") {
    dist = dist * 0.8684;
  }
  return dist;
};

closestTo = function(lat, lng, objects) {
  return min(map(objects, function(loc) {
    loc.distance = distance(lat, lng, loc.lat, loc.lng);
    return loc;
  }), function(loc) {
    return loc.distance;
  });
};

numbersEqual = function(num1, num2) {
  return Math.abs(num1 - num2) < 1e-6;
};

GrouponGsmDeals = (function() {
  function GrouponGsmDeals(deals, query, I18n, options) {
    var category, categoryDeals, deal, index, j, l, len, len1, maxDeals, noHero, overrideHero, ref2, ref3, ref4;
    if (options == null) {
      options = {};
    }
    noHero = (query != null ? query.gsm_nh : void 0) === '1' || options.forceNoHero;
    this.rapiQueryPhrase = options.rapiQuery;
    ref2 = getGridLayout({
      hasLhNav: options != null ? options.hasLeftHandNav : void 0,
      forceGridView: options != null ? options.forceGrid : void 0,
      forceLayoutType: options != null ? options.forceLayoutType : void 0,
      hasMaps: options != null ? options.hasMaps : void 0
    }), this.gridLayout = ref2.gridLayout, this.toggle_state = ref2.toggle_state, this.has_lh_nav = ref2.has_lh_nav;
    this.dealSpaceLayout = options != null ? options.dealSpaceLayout : void 0;
    this.lazyLoadDealTileImages = (options != null ? options.lazyLoadImages : void 0) != null ? options.lazyLoadImages : true;
    this.featuredDeal = null;
    this.neighborhood = options.neighborhood, this.searchLocation = options.searchLocation, this.logger = options.logger;
    maxDeals = options.MAX_DEALS !== void 0 && typeof options.MAX_DEALS === 'number' ? options.MAX_DEALS : MAX_DEALS;
    if (options.dealDisplayMap) {
      if (!noHero) {
        this.featuredDeal = deals[0];
      }
      options.dealDisplayMap.categories = reject(options.dealDisplayMap.categories, function(category) {
        return category.singular === 'Travel';
      });
      ref3 = options.dealDisplayMap.categories;
      for (j = 0, len = ref3.length; j < len; j++) {
        category = ref3[j];
        categoryDeals = filter(category.deals, (function(_this) {
          return function(dealIdx) {
            return (deals[dealIdx] != null) && ((_this.featuredDeal == null) || dealIdx !== 0);
          };
        })(this));
        categoryDeals = map(categoryDeals, (function(_this) {
          return function(dealIdx) {
            var deal;
            deal = deals[dealIdx];
            return _this.decorate(deal);
          };
        })(this));
        category.dealGrid = categoryDeals.slice(0, maxDeals);
        category.dealGrid.heading = I18n.t("js.modules.deals.gridHeading", {
          singularCategory: category.singular,
          pluralCategory: category.plural
        });
        category.dealGrid.url = options.baseUrl + "/" + category.url;
      }
      this.categoryGrid = options.dealDisplayMap.categories;
      this.dealGrid = [];
    } else {
      if (overrideHero = query != null ? query.hero : void 0) {
        noHero = false;
        deals = reject(deals, (function(_this) {
          return function(deal) {
            if (deal.id === overrideHero) {
              _this.featuredDeal = deal;
              return true;
            }
          };
        })(this));
      }
      if (!noHero) {
        if (this.featuredDeal == null) {
          this.featuredDeal = deals.shift();
        }
      }
      this.dealGrid = deals.slice(0, maxDeals);
      ref4 = this.dealGrid;
      for (index = l = 0, len1 = ref4.length; l < len1; index = ++l) {
        deal = ref4[index];
        this.adDecorate(deal, index, this.dealGrid.length, options != null ? options.inFlowAds : void 0);
      }
      this.categoryGrid = null;
    }
    this.dealGrid.slice(3, this.dealGrid.length).map(function(deal) {
      return deal.lazyLoadDealTileImage = true;
    });
    this.allowGridToggle = true;
    if (options.disallowGridToggle) {
      this.allowGridToggle = false;
    }
  }

  GrouponGsmDeals.prototype.viewObjects = function() {
    var ref2;
    return {
      featuredDeal: this.decorate(this.featuredDeal),
      dealGrid: map(this.dealGrid, (function(_this) {
        return function(deal) {
          return _this.decorate(deal);
        };
      })(this)),
      gridLayout: this.gridLayout,
      categoryGrid: this.categoryGrid,
      allowGridToggle: this.allowGridToggle,
      dealSpaceLayout: this.dealSpaceLayout,
      toggle_state: this.toggle_state,
      lazyLoadDealTileImages: this.lazyLoadDealTileImages,
      has_lh_nav: this.has_lh_nav,
      hasDeals: this.featuredDeal || !!((ref2 = this.dealGrid) != null ? ref2.length : void 0),
      neighborhood: this.neighborhood,
      searchLocation: this.searchLocation
    };
  };

  GrouponGsmDeals.prototype.adDecorate = function(deal, index, total, inFlowAds) {
    var positions, slotDivIDs;
    if (deal == null) {
      return;
    }
    if (!((inFlowAds != null) && (inFlowAds.positions != null) && (inFlowAds.slotDivIDs != null) && (inFlowAds.localHomePositions != null))) {
      return;
    }
    positions = inFlowAds.positions;
    slotDivIDs = inFlowAds.slotDivIDs;
    if (index === (inFlowAds.isLocalHome ? inFlowAds.localHomePositions[0] : positions[0])) {
      deal.enableAd = true;
      deal.adSlot = inFlowAds.slotDivIDs[0];
      deal.adPosition = 1;
      if (inFlowAds.isLocalHome) {
        return deal.localHomePageCss = "local-home-center";
      }
    } else if (index === (inFlowAds.isLocalHome ? inFlowAds.localHomePositions[1] : positions[1])) {
      deal.enableAd = true;
      deal.adSlot = slotDivIDs != null ? slotDivIDs[1] : void 0;
      deal.adPosition = 2;
      if (inFlowAds.isLocalHome) {
        return deal.localHomePageCss = "local-home-center";
      }
    } else if (index === total - 1 && total >= (inFlowAds.isLocalHome ? inFlowAds.localHomePositions[2] : positions[2]) && inFlowAds.hasGrouponGuide) {
      deal.enableAd = true;
      deal.adSlot = slotDivIDs != null ? slotDivIDs[2] : void 0;
      deal.adPosition = 3;
      if (inFlowAds.isLocalHome) {
        return deal.localHomePageCss = "local-home-center";
      }
    } else {
      return deal.enableAd = false;
    }
  };

  GrouponGsmDeals.prototype.debugLog = function(msg, obj) {
    if (this.logger) {
      msg = "[DEALS PRESENTER]: " + msg;
      if (obj) {
        msg = msg + ": ";
      }
      return this.logger.debug(msg, obj);
    }
  };

  GrouponGsmDeals.prototype.decorate = function(deal) {
    var allRedemptionLocs, dealTzOffset, options, rating, reducer, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, valueAmt;
    if (deal == null) {
      return null;
    }
    if (deal.priceSummary == null) {
      options = deal != null ? (ref2 = deal.options) != null ? ref2[0] : void 0 : void 0;
      if (!options) {
        deal.priceSummary = {
          price: {
            formattedAmount: ''
          },
          value: {
            formattedAmount: ''
          }
        };
      } else {
        if (!options.value) {
          valueAmt = (parseFloat(options.price.amount) + parseFloat(options.discount.amount)).toFixed(2);
          options.value = {
            amount: '' + valueAmt,
            currencyCode: options.discount.currencyCode,
            formattedAmount: currencySymbol(options.discount.currencyCode) + valueAmt
          };
        }
        deal.priceSummary = {
          discountPercent: Math.round(options.price.amount / options.value.amount * 100),
          price: options.price,
          value: options.value,
          minimumPurchaseQuantity: options.minimumPurchaseQuantity
        };
      }
    }
    if (this.searchLocation) {
      reducer = function(memo, opt) {
        var j, len, newLoc, ref3;
        ref3 = opt.redemptionLocations || [];
        for (j = 0, len = ref3.length; j < len; j++) {
          newLoc = ref3[j];
          if (!some(memo, function(oldLoc) {
            return numbersEqual(newLoc.lat, oldLoc.lat) && numbersEqual(newLoc.lng, oldLoc.lng);
          })) {
            memo.push(newLoc);
          }
        }
        return memo;
      };
      allRedemptionLocs = reduce(deal != null ? deal.options : void 0, reducer, []);
      deal.redeemLocObj = closestTo(this.searchLocation.lat, this.searchLocation.lng, allRedemptionLocs);
      deal.redeemLocObj.distance = distance(this.searchLocation.lat, this.searchLocation.lng, deal.redeemLocObj.lat, deal.redeemLocObj.lng);
    } else {
      deal.redeemLocObj = deal != null ? (ref3 = deal.options) != null ? (ref4 = ref3[0]) != null ? (ref5 = ref4.redemptionLocations) != null ? ref5[0] : void 0 : void 0 : void 0 : void 0;
    }
    if (!deal.redemptionLocation || deal.redemptionLocation.length === 0 || deal.redemptionLocation === (deal != null ? (ref6 = deal.merchant) != null ? ref6.name : void 0 : void 0)) {
      deal.redemptionLocation = (ref7 = deal.redeemLocObj) != null ? ref7.city : void 0;
    }
    deal.announcementTitle = deal.title || deal.announcementTitle;
    if ((((ref8 = deal.priceSummary) != null ? ref8.price : void 0) != null) && (((ref9 = deal.priceSummary) != null ? ref9.value : void 0) != null)) {
      if (deal.priceSummary.price.formattedAmount) {
        deal.priceSummary.price.formattedAmount = deal.priceSummary.price.formattedAmount.replace(/\D00(\D*)$/, '$1');
      }
      if (deal.priceSummary.value.formattedAmount) {
        deal.priceSummary.value.formattedAmount = deal.priceSummary.value.formattedAmount.replace(/\D00(\D*)$/, '$1');
      }
      deal.announcementTitle = interpolatePricing(deal.announcementTitle, deal.priceSummary.price, deal.priceSummary.value);
    }
    if (((ref10 = deal.priceSummary) != null ? ref10.discountPercent : void 0) != null) {
      deal.priceSummary.isDiscounted = deal.priceSummary.discountPercent > 0;
    }
    if (deal.announcementTitle == null) {
      deal.announcementTitle = (deal != null ? (ref11 = deal.merchant) != null ? ref11.name : void 0 : void 0) || deal.id;
    }
    if (((ref12 = deal.priceSummary) != null ? (ref13 = ref12.price) != null ? ref13.currencyCode : void 0 : void 0) != null) {
      deal.announcementTitle = deal.announcementTitle.replace(/\$/g, currencySymbol(deal.priceSummary.price.currencyCode));
    }
    if (deal.largeImageUrl == null) {
      deal.largeImageUrl = deal.grid4ImageUrl;
    }
    deal.bloodHoundData = {
      accessType: deal != null ? deal.accessType : void 0,
      permalink: deal != null ? deal.id : void 0
    };
    deal.bloodHoundString = JSON.stringify(deal.bloodHoundData);
    if ((ref14 = deal.locations) != null ? ref14[0] : void 0) {
      deal.location = deal.locations[0];
      deal.location.formattedDistance = ((ref15 = deal.location.distance) != null ? ref15.toFixed(1) : void 0) + " miles";
    }
    if ((deal != null ? (ref16 = deal.merchant) != null ? (ref17 = ref16.ratings) != null ? ref17.length : void 0 : void 0 : void 0) > 0) {
      reducer = function(memo, rating) {
        rating.rating = rating.rating / (rating.basis || 5.0) * 5.0;
        memo.average = (memo.average * memo.total + rating.rating * rating.reviewsCount) / (memo.total + rating.reviewsCount);
        memo.total = memo.total + rating.reviewsCount;
        return memo;
      };
      rating = reduce(deal.merchant.ratings, reducer, {
        total: 0,
        average: 0.0
      });
      if (rating.average >= 0.0 && rating.average <= 5.0) {
        deal.rating = rating;
        deal.rating.average = Math.floor(deal.rating.average * 2) / 2.0;
        deal.rating.stars = new Array(Math.floor(deal.rating.average));
        deal.rating.noStars = new Array(Math.floor(5 - deal.rating.average));
        deal.rating.halfStar = Math.abs(deal.rating.average - Math.round(deal.rating.average)) > 1e-4;
      }
    }
    if (deal != null ? deal.isNowDeal : void 0) {
      if (Date.parse(deal.endAt) >= (new Date).getTime()) {
        if (((ref18 = deal.locations) != null ? ref18[0] : void 0) && deal.startRedemptionAt.indexOf('Z') !== -1) {
          dealTzOffset = deal.locations[0].timezoneOffsetInSeconds * 1000;
          deal.redemptionTime = '' + formatIsoTime(deal.startRedemptionAt, dealTzOffset) + ' - ' + formatIsoTime(deal.endRedemptionAt, dealTzOffset);
        } else {
          deal.redemptionTime = '' + formatTime(deal.startRedemptionAt) + ' - ' + formatTime(deal.endRedemptionAt);
        }
      } else {
        deal.redemptionTime = 'Deal not available';
      }
    }
    deal.writeup = writeupFor(deal, this.rapiQueryPhrase);
    return deal;
  };

  return GrouponGsmDeals;

})();

module.exports = GrouponGsmDeals;


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../helpers/html":8}],5:[function(require,module,exports){
var DealGridToggle;

DealGridToggle = (function() {
  function DealGridToggle() {
    this.pageWrap = $('.wrap-gsm-page');
    this.dealSpace = $('.deal-space');
    this.dealMerchantName = this.dealSpace.find('p.merchant-name');
    this.dealImage = this.dealSpace.find('img.deal-image');
    this.viewDealButton = this.dealSpace.find('.view-deal-button');
    this.gridIcon = $('.grid_toggle .grid');
    this.listIcon = $('.grid_toggle .list');
  }

  DealGridToggle.prototype.parseQueryString = function() {
    var splitKeyVal;
    splitKeyVal = function(obj, keyVal) {
      var key, ref, val;
      ref = keyVal.split("="), key = ref[0], val = ref[1];
      key = decodeURIComponent(key);
      val = decodeURIComponent(val);
      obj[key] = val;
      return obj;
    };
    return _.inject(((typeof location !== "undefined" && location !== null ? location.search : void 0) || '?').replace(/^\?/, '').split("&"), splitKeyVal, {});
  };

  DealGridToggle.prototype.showGridView = function() {
    this.pageWrap.removeClass('view-list').addClass('view-grid');
    this.dealSpace.removeClass('deal-tile-list-view').addClass('deal-tile-grid-view').attr('data-bhw', 'GsmCategoryDealsContainerThreeAcross');
    GIG.Utils.truncateElements(this.dealSpace, {
      watch: false
    });
    this.dealMerchantName.attr('data-bhw', 'categoryDealsThreeAcrossMerchantName');
    this.dealImage.attr('data-bhw', 'categoryDealsThreeAcrossImage');
    return this.viewDealButton.removeAttr('data-bhw');
  };

  DealGridToggle.prototype.showListView = function() {
    this.pageWrap.removeClass('view-grid').addClass('view-list');
    this.dealSpace.removeClass('deal-tile-grid-view').addClass('deal-tile-list-view').attr('data-bhw', 'GsmCategoryDealsContainerOneAcross');
    GIG.Utils.truncateElements(this.dealSpace, {
      watch: false
    });
    this.dealMerchantName.attr('data-bhw', 'categoryDealsOneAcrossMerchantName');
    this.dealImage.attr('data-bhw', 'categoryDealsOneAcrossImage');
    return this.viewDealButton.attr('data-bhw', 'categoryDealsOneAcrossViewDealButton');
  };

  DealGridToggle.prototype.addDealGridToggleBehaviors = function() {
    this.gridIcon.unbind('click').click((function(_this) {
      return function() {
        _this.showGridView();
        return Cookie.set('list_or_grid_view', 'GRID');
      };
    })(this));
    return this.listIcon.unbind('click').click((function(_this) {
      return function() {
        _this.showListView();
        return Cookie.set('list_or_grid_view', 'LIST');
      };
    })(this));
  };

  return DealGridToggle;

})();

$(document).ready(function() {
  var dealGridToggle, ref, ref1, toggleOverride, toggleState;
  if ($('.allow-toggle').length) {
    dealGridToggle = new DealGridToggle();
    toggleOverride = (ref = dealGridToggle.parseQueryString()) != null ? (ref1 = ref.lyt) != null ? ref1.toUpperCase() : void 0 : void 0;
    toggleState = Cookie.get('list_or_grid_view');
    if (toggleOverride != null) {
      Cookie.set('list_or_grid_view', toggleOverride);
      toggleState = toggleOverride;
    }
    if (toggleState != null) {
      if (toggleState === 'GRID') {
        dealGridToggle.showGridView();
      } else if (toggleState === 'LIST') {
        dealGridToggle.showListView();
      }
    }
    return dealGridToggle.addDealGridToggleBehaviors();
  }
});



},{}],6:[function(require,module,exports){
var ClientDealsUpdate, GrouponGsmDeals, clientSideDealGridTemplate;

require('../../optimize_config/frontend/optimize_config');

require('Hogan');

GrouponGsmDeals = require('./deals');

clientSideDealGridTemplate = require('../client_side_deal_grid.html.mustache');

module.exports = ClientDealsUpdate = (function() {
  function ClientDealsUpdate(config) {
    this.hostname = config.hostname;
    this.apiPath = this.pathFromHref();
    this.response = null;
    this.template = clientSideDealGridTemplate;
  }

  ClientDealsUpdate.prototype.pathFromHref = function() {
    var path, pathAndQuery;
    pathAndQuery = window.location.href.toString().split('?');
    if (!(path = $('.deal-space').data('url'))) {
      path = pathAndQuery[0].split(window.location.host)[1] + ".json";
    }
    if (pathAndQuery[1]) {
      path += "?" + pathAndQuery[1];
    }
    return path;
  };

  ClientDealsUpdate.prototype.apiUrl = function() {
    var ref;
    if (((ref = this.hostname) != null ? ref.length : void 0) > 0) {
      return '//' + this.hostname + this.apiPath;
    } else {
      return this.apiPath;
    }
  };

  ClientDealsUpdate.prototype.deals = function(responseCb, errorCb, completeCb) {
    var url;
    if (this.response != null) {
      if (this.response.success_data != null) {
        responseCb(this.response.success_data);
      } else {
        errorCb(this.response.jqxhr, this.response.textStatus, this.response.errorThrown);
      }
      completeCb(this.response.jqxhr, this.response.textStatus);
      return;
    }
    url = this.apiUrl();
    return $.ajax({
      url: url,
      success: (function(_this) {
        return function(data) {
          _this.response || (_this.response = {});
          _this.response.success_data = data;
          return responseCb(data);
        };
      })(this),
      error: (function(_this) {
        return function(jqxhr, textStatus, errorThrown) {
          _this.response || (_this.response = {});
          _this.response.jqxhr = jqxhr;
          _this.response.textStatus = textStatus;
          _this.response.errorThrown = errorThrown;
          return errorCb(jqxhr, textStatus, errorThrown);
        };
      })(this),
      complete: completeCb,
      timeout: 20000,
      dataType: 'jsonp'
    });
  };

  ClientDealsUpdate.prototype.load_deals = function(waitingDiv, targetDiv, cb) {
    var clientTemplate, completeCb, errorCb, hadServerDeals, hasLhNavbar, oldDealsMarkup, responseCb;
    clientTemplate = this.template;
    oldDealsMarkup = $(targetDiv).html();
    $(targetDiv).html($(waitingDiv).html());
    hasLhNavbar = !!$('#refinement-bar').length;
    hadServerDeals = true;
    responseCb = function(data) {
      var deals, new_html;
      deals = new GrouponGsmDeals(data, {}, I18n, {
        hasLeftHandNav: hasLhNavbar
      });
      new_html = clientTemplate.render(I18n.mixin(deals.viewObjects(), I18n));
      if (new_html.length > 0) {
        new_html = $(new_html).filter('*');
        $(targetDiv).html(new_html.html());
        return GIG.Utils.truncateElements($(targetDiv));
      } else if (hadServerDeals) {
        return $(targetDiv).html(oldDealsMarkup);
      } else {
        return $(targetDiv).html('');
      }
    };
    errorCb = function(jqxhr, textStatus, errorThrown) {
      if (hadServerDeals) {
        return $(targetDiv).html(oldDealsMarkup);
      } else {
        return $(targetDiv).html('');
      }
    };
    completeCb = function(jqxhr, textStatus) {
      if (cb != null) {
        return cb();
      }
    };
    return this.deals(responseCb, errorCb, completeCb);
  };

  return ClientDealsUpdate;

})();



},{"../../optimize_config/frontend/optimize_config":10,"../client_side_deal_grid.html.mustache":3,"./deals":4,"Hogan":15}],7:[function(require,module,exports){
var strip_html;

module.exports = strip_html = function(str, tags) {
  if (tags == null) {
    tags = null;
  }
  if (!str) {
    return str;
  }
  if (tags) {
    str = str.replace(new RegExp("</?\\s*(" + (tags.join('|')) + ")( [^>]*)?>", "g"), '');
  } else {
    str = str.replace("</p>", "\n\n").replace("<p>", "");
    str = str.replace(/(<\?[a-z]*(\s[^>]*)?\?(>|$)|<!\[[a-z]*\[|\]\]>|<!DOCTYPE[^>]*?(>|$)|<!--[\s\S]*?(-->|$)|<[a-z?!\/]([a-z0-9_:.])*(\s[^>]*)?(>|$))/gi, '');
  }
  return str;
};



},{}],8:[function(require,module,exports){
(function (global){
var StringScanner, TAG_OR_SPACE_REGEX, each, getSentenceRegion, markdown;

markdown = require('markdown').markdown;

each = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).each;

StringScanner = require('./string_scanner');

TAG_OR_SPACE_REGEX = /<(\/?|\s*?)([^\s>]+)([^>]*)>| |$/;

module.exports = {
  markdownToHtml: function(str) {
    return markdown.toHTML(str);
  },
  stripHtml: function(str, tags) {
    if (tags == null) {
      tags = null;
    }
    if (!str) {
      return str;
    }
    if (tags) {
      str = str.replace(new RegExp("</?\\s*(" + (tags.join('|')) + ")( [^>]*)?>", "g"), '');
    } else {
      str = str.replace("</p>", "\n\n").replace("<p>", "");
      str = str.replace(/<[^>]*>/gi, '');
    }
    return str;
  },
  truncateHtml: function(html, options) {
    var attrs, chunk, ctag, i, idx, j, leftovers, len, len1, length, max_len, omission, ref, ref1, return_leftovers, s, stack, tag, truncated;
    if (options == null) {
      options = {};
    }
    if (html == null) {
      return html;
    }
    html = html.replace("\n", " ");
    max_len = options.length || 155;
    omission = options.omission || '&hellip;';
    return_leftovers = options.return_leftovers;
    s = new StringScanner(html);
    truncated = '';
    length = 0;
    stack = [];
    while (length < max_len) {
      chunk = s.scanUntil(TAG_OR_SPACE_REGEX);
      if (chunk) {
        if (s.captures()[1]) {
          ctag = s.captures()[0];
          tag = s.captures()[1];
          attrs = s.captures()[2];
          if (tag[tag.length - 1] !== '/') {
            if (ctag !== '/') {
              stack.push(tag);
            } else {
              stack.pop();
            }
          }
          length += chunk.length - s.match().length;
        } else {
          length += chunk.length;
        }
        truncated += chunk;
      } else {
        length = max_len;
        omission = '';
        truncated = html;
        break;
      }
    }
    truncated += omission;
    ref = stack.reverse();
    for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
      tag = ref[idx];
      if (tag !== 'br') {
        truncated += "</" + tag + ">";
      }
    }
    if (return_leftovers) {
      leftovers = s.rest();
      ref1 = stack.reverse();
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        tag = ref1[j];
        if (tag !== 'br') {
          leftovers = "<" + tag + ">" + leftovers;
        }
      }
      return [truncated, leftovers];
    } else {
      return truncated;
    }
  },
  createSnippet: function(text, keyword, tags) {
    var blackListRegexp, candidates, i, index, keywordRegexp, len, matches, rv, selected, sent, sentences;
    if (tags == null) {
      tags = null;
    }
    if (!text) {
      return null;
    }
    if (!keyword) {
      return null;
    }
    keyword = keyword.trim();
    if (tags) {
      text = text.replace(new RegExp("</?\\s*(" + (tags.join('|')) + ")( [^>]*)?>", "g"), '');
    } else {
      text = text.replace(/<\/[^>]*>/gi, '.');
      text = text.replace(/<[^>]*>/gi, '');
    }
    sentences = text.match(/(^|\G|\s).*?(\.|$|\\z)/g);
    keywordRegexp = new RegExp("\\b" + keyword + "s?(\\b|\\.|$|\\z)", 'i');
    blackListRegexp = new RegExp("(serious (side effects|side-effects)|safety considerations)", 'i');
    candidates = [];
    for (i = 0, len = sentences.length; i < len; i++) {
      sent = sentences[i];
      matches = sent.match(keywordRegexp);
      if (matches !== null) {
        if (blackListRegexp.test(sent)) {
          continue;
        }
        candidates.push({
          sentence: sent.trim(),
          match: matches[0]
        });
      }
    }
    if (candidates.length === 0) {
      return null;
    }
    index = Math.floor(Math.random() * candidates.length);
    selected = getSentenceRegion(candidates[index].sentence, candidates[index].match);
    if ((selected != null ? selected.sentence : void 0) != null) {
      rv = selected.sentence.replace(new RegExp("" + selected.match, 'g'), "<mark>" + selected.match + "</mark>");
      return "<p>" + rv + "</p>";
    } else {
      return null;
    }
  }
};

getSentenceRegion = function(text, match) {
  var begin, end, limit, matchBegin, matchEnd, matchRegExp, padding;
  limit = 200;
  padding = 10;
  if (text.length < limit) {
    return {
      sentence: text,
      match: match
    };
  }
  matchRegExp = new RegExp("" + match, 'g');
  matchBegin = text.search(matchRegExp);
  matchEnd = matchBegin + match.length;
  if (matchBegin === -1) {
    return {
      sentence: text,
      match: match
    };
  }
  if (matchEnd + padding <= limit) {
    return {
      sentence: text.substring(0, limit) + "...",
      match: match
    };
  }
  if (matchBegin > limit) {
    begin = Math.min(matchBegin - padding, text.length - limit);
    end = Math.min(begin + limit, text.length);
  } else {
    end = Math.min(matchEnd + padding, text.length);
    begin = Math.max(0, end - limit);
  }
  while (text.charAt(begin) !== ' ' && begin > 0) {
    begin -= 1;
  }
  while (text.charAt(end) !== ' ' && text.charAt(end) !== '.' && end < text.length + 1) {
    end += 1;
  }
  if (begin > 0 && end < text.length) {
    return {
      sentence: "..." + text.substring(begin, end) + "...",
      match: match
    };
  }
  if (begin > 0) {
    return {
      sentence: "..." + text.substring(begin, end),
      match: match
    };
  }
  if (end < text.length) {
    return {
      sentence: text.substring(begin, end) + "...",
      match: match
    };
  }
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./string_scanner":9,"markdown":16}],9:[function(require,module,exports){
var StringScanner;

StringScanner = (function() {
  function StringScanner(str1) {
    this.str = str1 != null ? str1 : '';
    this.str = '' + this.str;
    this.pos = 0;
    this.lastMatch = {
      reset: function() {
        this.str = null;
        this.captures = [];
        this.start = -1;
        return this;
      }
    }.reset();
    this;
  }

  StringScanner.prototype.bol = function() {
    return this.pos <= 0 || (this.str[this.pos - 1] === "\n");
  };

  StringScanner.prototype.captures = function() {
    return this.lastMatch.captures;
  };

  StringScanner.prototype.check = function(pattern) {
    var matches;
    if (this.str.substr(this.pos).search(pattern) !== 0) {
      this.lastMatch.reset();
      return null;
    }
    matches = this.str.substr(this.pos).match(pattern);
    this.lastMatch.str = matches[0];
    this.lastMatch.start = this.str.indexOf(matches[0]);
    this.lastMatch.captures = matches.slice(1);
    return this.lastMatch.str;
  };

  StringScanner.prototype.checkUntil = function(pattern) {
    var matches, patternPos;
    patternPos = this.str.substr(this.pos).search(pattern);
    if (patternPos < 0) {
      this.lastMatch.reset();
      return null;
    }
    matches = this.str.substr(this.pos + patternPos).match(pattern);
    this.lastMatch.captures = matches.slice(1);
    this.lastMatch.start = patternPos;
    return this.lastMatch.str = this.str.substr(this.pos, patternPos) + matches[0];
  };

  StringScanner.prototype.clone = function() {
    var clone, prop, ref, value;
    clone = new this.constructor(this.str);
    clone.pos = this.pos;
    clone.lastMatch = {};
    ref = this.lastMatch;
    for (prop in ref) {
      value = ref[prop];
      clone.lastMatch[prop] = value;
    }
    return clone;
  };

  StringScanner.prototype.concat = function(str) {
    this.str += str;
    return this;
  };

  StringScanner.prototype.eos = function() {
    return this.pos === this.str.length;
  };

  StringScanner.prototype.exists = function(pattern) {
    var matches, patternPos;
    patternPos = this.str.substr(this.pos).search(pattern);
    if (patternPos < 0) {
      this.lastMatch.reset();
      return null;
    }
    matches = this.str.substr(this.pos + patternPos).match(pattern);
    this.lastMatch.str = matches[0];
    this.lastMatch.captures = matches.slice(1);
    return patternPos;
  };

  StringScanner.prototype.getch = function() {
    return this.scan(/./);
  };

  StringScanner.prototype.match = function() {
    return this.lastMatch.str;
  };

  StringScanner.prototype.matches = function(pattern) {
    this.check(pattern);
    return this.matchSize();
  };

  StringScanner.prototype.matched = function() {
    return this.lastMatch.str != null;
  };

  StringScanner.prototype.matchSize = function() {
    if (this.matched()) {
      return this.match().length;
    } else {
      return null;
    }
  };

  StringScanner.prototype.peek = function(len) {
    return this.str.substr(this.pos, len);
  };

  StringScanner.prototype.pointer = function() {
    return this.pos;
  };

  StringScanner.prototype.setPointer = function(pos) {
    pos = +pos;
    if (pos < 0) {
      pos = 0;
    }
    if (pos > this.str.length) {
      pos = this.str.length;
    }
    return this.pos = pos;
  };

  StringScanner.prototype.reset = function() {
    this.lastMatch.reset();
    this.pos = 0;
    return this;
  };

  StringScanner.prototype.rest = function() {
    return this.str.substr(this.pos);
  };

  StringScanner.prototype.scan = function(pattern) {
    var chk;
    chk = this.check(pattern);
    if (chk != null) {
      this.pos += chk.length;
    }
    return chk;
  };

  StringScanner.prototype.scanUntil = function(pattern) {
    var chk;
    chk = this.checkUntil(pattern);
    if (chk != null) {
      this.pos += chk.length;
    }
    return chk;
  };

  StringScanner.prototype.skip = function(pattern) {
    this.scan(pattern);
    return this.matchSize();
  };

  StringScanner.prototype.skipUntil = function(pattern) {
    this.scanUntil(pattern);
    return this.matchSize();
  };

  StringScanner.prototype.string = function() {
    return this.str;
  };

  StringScanner.prototype.terminate = function() {
    this.pos = this.str.length;
    this.lastMatch.reset();
    return this;
  };

  StringScanner.prototype.toString = function() {
    var data, positition;
    positition = this.eos() ? 'fin' : this.pos + "/" + this.str.length;
    data = this.str.length > 8 ? (this.str.substr(0, 5)) + "..." : this.str;
    return "#<StringScanner " + position + " @ " + data + ">";
  };

  return StringScanner;

})();

StringScanner.prototype.beginningOfLine = StringScanner.prototype.bol;

StringScanner.prototype.clear = StringScanner.prototype.terminate;

StringScanner.prototype.dup = StringScanner.prototype.clone;

StringScanner.prototype.endOfString = StringScanner.prototype.eos;

StringScanner.prototype.exist = StringScanner.prototype.exists;

StringScanner.prototype.getChar = StringScanner.prototype.getch;

StringScanner.prototype.position = StringScanner.prototype.pointer;

StringScanner.StringScanner = StringScanner;

module.exports = StringScanner;



},{}],10:[function(require,module,exports){
var GrouponGsm;

GrouponGsm = {};

if (typeof Finch !== "undefined" && Finch !== null) {
  GrouponGsm.query_string = function() {
    return window.location.search;
  };
  GrouponGsm.request_from_certain_channel = function(channel) {
    var regex;
    regex = new RegExp(["[?&]utm_campaign=US_\\w{2}_", channel, "_"].join(""), "i");
    return regex.test(this.query_string());
  };
  GrouponGsm.explicitly_skip_modal = function() {
    return /[?&]sm=0/i.test(this.query_string());
  };
  GrouponGsm.user_has_sub_cookie = function() {
    var cookiePresent, sub_cookies;
    sub_cookies = ["subscriber_email", "scid", "l", "user_id"];
    cookiePresent = false;
    $.each(sub_cookies, function(index, value) {
      if (Cookie.get('value')) {
        cookiePresent = true;
        return false;
      }
    });
    return cookiePresent;
  };
  GrouponGsm.user_has_hide_sub_cookie = function() {
    return Cookie.get("hide_sub_banner") || Cookie.get("hide_sub_modal");
  };
  Finch.Experiments.Global.guards = {
    on_gsm_platform_page: function() {
      return true;
    },
    request_from_display_ads: function() {
      return GrouponGsm.request_from_certain_channel('DPN');
    },
    request_not_from_display_ads: function() {
      return !GrouponGsm.request_from_certain_channel('DPN');
    },
    request_from_sem_ads: function() {
      return GrouponGsm.request_from_certain_channel('SEA');
    },
    request_from_normal_seo: function() {
      return !GrouponGsm.request_from_certain_channel('DPN' && !GrouponGsm.request_from_certain_channel('SEA'));
    },
    user_has_no_sub_cookie: function() {
      return !GrouponGsm.user_has_sub_cookie();
    },
    user_has_no_hide_sub_cookie: function() {
      return !GrouponGsm.user_has_hide_sub_cookie();
    },
    not_explicitly_skip_modal: function() {
      return !GrouponGsm.explicitly_skip_modal();
    }
  };
  if (Finch.TrackingHubTracker == null) {
    Finch.TrackingHubTracker = {
      track: function(experimentSets) {
        return _(experimentSets).each(function(experimentSet) {
          var error, experimentId, layerName, variantName;
          layerName = experimentSet.layer.name;
          experimentId = experimentSet.experiment.id;
          variantName = experimentSet.variant;
          error = experimentSet.error;
          return OptimizeSuite.TrackingHub.add("finch-experiment", {
            layer: layerName,
            experiment: experimentId,
            variant: variantName,
            error: error
          });
        });
      }
    };
  }
}



},{}],11:[function(require,module,exports){
Groupon.ui = Groupon.ui || {};

Groupon.ui.GSMEditorialWidget = {
  selector: {
    expandable: '.has-expando',
    mainColumn: '.article-main',
    toggle: '.toggler',
    widget: '.editorial-widget'
  },
  expandableElements: null,
  toggleElements: null,
  closedHeightFix: 8,
  closedPx: 32,
  initExpandables: function(options) {
    if ((options != null ? options.closedHeightFix : void 0) != null) {
      this.closedHeightFix = options.closedHeightFix;
    }
    if ((options != null ? options.closedPx : void 0) != null) {
      this.closedPx = options.closedPx;
    }
    this.expandableElements = $(this.selector.mainColumn).find(this.selector.expandable);
    if (this.expandableElements.length) {
      this.expandableElements.each(function() {
        var articleInfo, articleTitle, el, readMoreLink, textElmt;
        el = $(this);
        textElmt = el.find('.body-text');
        articleInfo = el.parent('.article-info').find('a');
        readMoreLink = articleInfo.attr('href');
        articleTitle = articleInfo.html();
        el.data('fullContent', textElmt.clone());
        el.dotdotdot({
          callback: function() {
            if (el.hasClass('go-to-article-page')) {
              return el.append("<span class='toggler'><a href='" + readMoreLink + "' title='" + articleTitle + "'>" + (I18n.t('js.modules.seo-platform-editorial.readMore')) + "</a></span>");
            }
          }
        });
        el.data('closedHeight', el.height() - this.closedHeightFix);
        return el.find('span.toggler').data('toggleState', 'closed');
      });
    }
    return this.makeExpandable();
  },
  makeExpandable: function() {
    this.toggleElements = $(this.selector.mainColumn).find(this.selector.toggle);
    if (this.toggleElements.length) {
      return this.toggleElements.on('click', this.toggleClickHandler);
    }
  },
  toggleClickHandler: function(event) {
    var el, expando, toggle;
    el = $(event.target);
    expando = el.closest('.has-expando');
    if (expando.hasClass('go-to-article-page')) {
      return;
    }
    if (el.data('toggleState') === 'closed') {
      el.data('toggleState', 'open');
      toggle = el.clone(true);
      expando.data('truncatedContent', expando.children().clone(true));
      toggle.text("" + (I18n.t('js.modules.seo-platform-editorial.readLess')));
      expando.empty().append(expando.data('fullContent'), toggle);
      expando.css({
        'height': 'auto',
        'max-height': ''
      });
      return $('#inner-wrap').removeClass('lbl').removeClass('collapsedArticleMargin').addClass('expandedArticleMargin');
    } else {
      el.data('toggleState', 'closed');
      toggle = el.clone(true).text("" + (I18n.t('js.modules.seo-platform-editorial.readMore')));
      expando.empty().append(expando.data('truncatedContent'));
      toggle.replaceAll(expando.find('span.toggler'));
      expando.css({
        'height': expando.data('closedHeight') + this.closedPx + 'px',
        'max-height': expando.data('closedHeight') + this.closedPx + 'px'
      });
      return $('#inner-wrap').removeClass('expandedArticleMargin').addClass('collapsedArticleMargin');
    }
  },
  initWidget: function(options) {
    $(this.selector.widget).show();
    return this.initExpandables(options);
  }
};



},{}],12:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],13:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = require('./compiler');
Hogan.Template = require('./template').Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;

},{"./compiler":12,"./template":14}],14:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],15:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */



var Hogan = {};

(function (Hogan, useArrayBuffer) {
  Hogan.Template = function (renderFunc, text, compiler, options) {
    this.r = renderFunc || this.r;
    this.c = compiler;
    this.options = options;
    this.text = text || '';
    this.buf = (useArrayBuffer) ? [] : '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // tries to find a partial in the curent scope and render it
    rp: function(name, context, partials, indent) {
      var partial = partials[name];

      if (!partial) {
        return '';
      }

      if (this.c && typeof partial == 'string') {
        partial = this.c.compile(partial, this.options);
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ls(val, ctx, partials, inverted, start, end, tags);
      }

      pass = (val === '') || !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        return ctx[ctx.length - 1];
      }

      for (var i = 1; i < names.length; i++) {
        if (val && typeof val == 'object' && names[i] in val) {
          cx = val;
          val = val[names[i]];
        } else {
          val = '';
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.lv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        if (v && typeof v == 'object' && key in v) {
          val = v[key];
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.lv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ho: function(val, cx, partials, text, tags) {
      var compiler = this.c;
      var options = this.options;
      options.delimiters = tags;
      var text = val.call(cx, text);
      text = (text == null) ? String(text) : text.toString();
      this.b(compiler.compile(text, options).render(cx, partials));
      return false;
    },

    // template result buffering
    b: (useArrayBuffer) ? function(s) { this.buf.push(s); } :
                          function(s) { this.buf += s; },
    fl: (useArrayBuffer) ? function() { var r = this.buf.join(''); this.buf = []; return r; } :
                           function() { var r = this.buf; this.buf = ''; return r; },

    // lambda replace section
    ls: function(val, ctx, partials, inverted, start, end, tags) {
      var cx = ctx[ctx.length - 1],
          t = null;

      if (!inverted && this.c && val.length > 0) {
        return this.ho(val, cx, partials, this.text.substring(start, end), tags);
      }

      t = val.call(cx);

      if (typeof t == 'function') {
        if (inverted) {
          return true;
        } else if (this.c) {
          return this.ho(t, cx, partials, this.text.substring(start, end), tags);
        }
      }

      return t;
    },

    // lambda replace variable
    lv: function(val, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = val.call(cx);

      if (typeof result == 'function') {
        result = coerceToString(result.call(cx));
        if (this.c && ~result.indexOf("{\u007B")) {
          return this.c.compile(result, this.options).render(cx, partials);
        }
      }

      return coerceToString(result);
    }

  };

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos =/\'/g,
      rQuot = /\"/g,
      hChars =/[&<>\"\']/;


  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp,'&amp;')
        .replace(rLt,'&lt;')
        .replace(rGt,'&gt;')
        .replace(rApos,'&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);




(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      tagTypes = {
        '#': 1, '^': 2, '/': 3,  '!': 4, '>': 5,
        '<': 6, '=': 7, '_v': 8, '{': 9, '&': 10
      };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push(new String(buf));
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (tokens[j].tag && tagTypes[tokens[j].tag] < tagTypes['_v']) ||
          (!tokens[j].tag && tokens[j].match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (!tokens[j].tag) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = tagTypes[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - ctag.length : i + otag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        token = null;

    while (tokens.length > 0) {
      token = tokens.shift();
      if (token.tag == '#' || token.tag == '^' || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
        instructions.push(token);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else {
        instructions.push(token);
      }
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  Hogan.generate = function (tree, text, options) {
    var code = 'var _=this;_.b(i=i||"");' + walk(tree) + 'return _.fl();';
    if (options.asString) {
      return 'function(c,p,i){' + code + ';}';
    }

    return new Hogan.Template(new Function('c', 'p', 'i', code), text, Hogan, options);
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function walk(tree) {
    var code = '';
    for (var i = 0, l = tree.length; i < l; i++) {
      var tag = tree[i].tag;
      if (tag == '#') {
        code += section(tree[i].nodes, tree[i].n, chooseMethod(tree[i].n),
                        tree[i].i, tree[i].end, tree[i].otag + " " + tree[i].ctag);
      } else if (tag == '^') {
        code += invertedSection(tree[i].nodes, tree[i].n,
                                chooseMethod(tree[i].n));
      } else if (tag == '<' || tag == '>') {
        code += partial(tree[i]);
      } else if (tag == '{' || tag == '&') {
        code += tripleStache(tree[i].n, chooseMethod(tree[i].n));
      } else if (tag == '\n') {
        code += text('"\\n"' + (tree.length-1 == i ? '' : ' + i'));
      } else if (tag == '_v') {
        code += variable(tree[i].n, chooseMethod(tree[i].n));
      } else if (tag === undefined) {
        code += text('"' + esc(tree[i]) + '"');
      }
    }
    return code;
  }

  function section(nodes, id, method, start, end, tags) {
    return 'if(_.s(_.' + method + '("' + esc(id) + '",c,p,1),' +
           'c,p,0,' + start + ',' + end + ',"' + tags + '")){' +
           '_.rs(c,p,' +
           'function(c,p,_){' +
           walk(nodes) +
           '});c.pop();}';
  }

  function invertedSection(nodes, id, method) {
    return 'if(!_.s(_.' + method + '("' + esc(id) + '",c,p,1),c,p,1,0,0,"")){' +
           walk(nodes) +
           '};';
  }

  function partial(tok) {
    return '_.b(_.rp("' +  esc(tok.n) + '",c,p,"' + (tok.indent || '') + '"));';
  }

  function tripleStache(id, method) {
    return '_.b(_.t(_.' + method + '("' + esc(id) + '",c,p,0)));';
  }

  function variable(id, method) {
    return '_.b(_.v(_.' + method + '("' + esc(id) + '",c,p,0)));';
  }

  function text(id) {
    return '_.b(' + id + ');';
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  },

  Hogan.cache = {};

  Hogan.compile = function(text, options) {
    // options
    //
    // asString: false (default)
    //
    // sectionTags: [{o: '_foo', c: 'foo'}]
    // An array of object with o and c fields that indicate names for custom
    // section tags. The example above allows parsing of {{_foo}}{{/foo}}.
    //
    // delimiters: A string that overrides the default delimiters.
    // Example: "<% %>"
    //
    options = options || {};

    var key = text + '||' + !!options.asString;

    var t = this.cache[key];

    if (t) {
      return t;
    }

    t = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = t;
  };
})(typeof exports !== 'undefined' ? exports : Hogan);


},{}],16:[function(require,module,exports){
// super simple module for the most common nodejs use case.
exports.markdown = require("./markdown");
exports.parse = exports.markdown.toHTML;

},{"./markdown":17}],17:[function(require,module,exports){
// Released under MIT license
// Copyright (c) 2009-2010 Dominic Baggott
// Copyright (c) 2009-2010 Ash Berlin
// Copyright (c) 2011 Christoph Dorn <christoph@christophdorn.com> (http://www.christophdorn.com)

/*jshint browser:true, devel:true */

(function( expose ) {

/**
 *  class Markdown
 *
 *  Markdown processing in Javascript done right. We have very particular views
 *  on what constitutes 'right' which include:
 *
 *  - produces well-formed HTML (this means that em and strong nesting is
 *    important)
 *
 *  - has an intermediate representation to allow processing of parsed data (We
 *    in fact have two, both as [JsonML]: a markdown tree and an HTML tree).
 *
 *  - is easily extensible to add new dialects without having to rewrite the
 *    entire parsing mechanics
 *
 *  - has a good test suite
 *
 *  This implementation fulfills all of these (except that the test suite could
 *  do with expanding to automatically run all the fixtures from other Markdown
 *  implementations.)
 *
 *  ##### Intermediate Representation
 *
 *  *TODO* Talk about this :) Its JsonML, but document the node names we use.
 *
 *  [JsonML]: http://jsonml.org/ "JSON Markup Language"
 **/
var Markdown = expose.Markdown = function(dialect) {
  switch (typeof dialect) {
    case "undefined":
      this.dialect = Markdown.dialects.Gruber;
      break;
    case "object":
      this.dialect = dialect;
      break;
    default:
      if ( dialect in Markdown.dialects ) {
        this.dialect = Markdown.dialects[dialect];
      }
      else {
        throw new Error("Unknown Markdown dialect '" + String(dialect) + "'");
      }
      break;
  }
  this.em_state = [];
  this.strong_state = [];
  this.debug_indent = "";
};

/**
 *  parse( markdown, [dialect] ) -> JsonML
 *  - markdown (String): markdown string to parse
 *  - dialect (String | Dialect): the dialect to use, defaults to gruber
 *
 *  Parse `markdown` and return a markdown document as a Markdown.JsonML tree.
 **/
expose.parse = function( source, dialect ) {
  // dialect will default if undefined
  var md = new Markdown( dialect );
  return md.toTree( source );
};

/**
 *  toHTML( markdown, [dialect]  ) -> String
 *  toHTML( md_tree ) -> String
 *  - markdown (String): markdown string to parse
 *  - md_tree (Markdown.JsonML): parsed markdown tree
 *
 *  Take markdown (either as a string or as a JsonML tree) and run it through
 *  [[toHTMLTree]] then turn it into a well-formated HTML fragment.
 **/
expose.toHTML = function toHTML( source , dialect , options ) {
  var input = expose.toHTMLTree( source , dialect , options );

  return expose.renderJsonML( input );
};

/**
 *  toHTMLTree( markdown, [dialect] ) -> JsonML
 *  toHTMLTree( md_tree ) -> JsonML
 *  - markdown (String): markdown string to parse
 *  - dialect (String | Dialect): the dialect to use, defaults to gruber
 *  - md_tree (Markdown.JsonML): parsed markdown tree
 *
 *  Turn markdown into HTML, represented as a JsonML tree. If a string is given
 *  to this function, it is first parsed into a markdown tree by calling
 *  [[parse]].
 **/
expose.toHTMLTree = function toHTMLTree( input, dialect , options ) {
  // convert string input to an MD tree
  if ( typeof input ==="string" ) input = this.parse( input, dialect );

  // Now convert the MD tree to an HTML tree

  // remove references from the tree
  var attrs = extract_attr( input ),
      refs = {};

  if ( attrs && attrs.references ) {
    refs = attrs.references;
  }

  var html = convert_tree_to_html( input, refs , options );
  merge_text_nodes( html );
  return html;
};

// For Spidermonkey based engines
function mk_block_toSource() {
  return "Markdown.mk_block( " +
          uneval(this.toString()) +
          ", " +
          uneval(this.trailing) +
          ", " +
          uneval(this.lineNumber) +
          " )";
}

// node
function mk_block_inspect() {
  var util = require("util");
  return "Markdown.mk_block( " +
          util.inspect(this.toString()) +
          ", " +
          util.inspect(this.trailing) +
          ", " +
          util.inspect(this.lineNumber) +
          " )";

}

var mk_block = Markdown.mk_block = function(block, trail, line) {
  // Be helpful for default case in tests.
  if ( arguments.length == 1 ) trail = "\n\n";

  var s = new String(block);
  s.trailing = trail;
  // To make it clear its not just a string
  s.inspect = mk_block_inspect;
  s.toSource = mk_block_toSource;

  if ( line != undefined )
    s.lineNumber = line;

  return s;
};

function count_lines( str ) {
  var n = 0, i = -1;
  while ( ( i = str.indexOf("\n", i + 1) ) !== -1 ) n++;
  return n;
}

// Internal - split source into rough blocks
Markdown.prototype.split_blocks = function splitBlocks( input, startLine ) {
  input = input.replace(/(\r\n|\n|\r)/g, "\n");
  // [\s\S] matches _anything_ (newline or space)
  // [^] is equivalent but doesn't work in IEs.
  var re = /([\s\S]+?)($|\n#|\n(?:\s*\n|$)+)/g,
      blocks = [],
      m;

  var line_no = 1;

  if ( ( m = /^(\s*\n)/.exec(input) ) != null ) {
    // skip (but count) leading blank lines
    line_no += count_lines( m[0] );
    re.lastIndex = m[0].length;
  }

  while ( ( m = re.exec(input) ) !== null ) {
    if (m[2] == "\n#") {
      m[2] = "\n";
      re.lastIndex--;
    }
    blocks.push( mk_block( m[1], m[2], line_no ) );
    line_no += count_lines( m[0] );
  }

  return blocks;
};

/**
 *  Markdown#processBlock( block, next ) -> undefined | [ JsonML, ... ]
 *  - block (String): the block to process
 *  - next (Array): the following blocks
 *
 * Process `block` and return an array of JsonML nodes representing `block`.
 *
 * It does this by asking each block level function in the dialect to process
 * the block until one can. Succesful handling is indicated by returning an
 * array (with zero or more JsonML nodes), failure by a false value.
 *
 * Blocks handlers are responsible for calling [[Markdown#processInline]]
 * themselves as appropriate.
 *
 * If the blocks were split incorrectly or adjacent blocks need collapsing you
 * can adjust `next` in place using shift/splice etc.
 *
 * If any of this default behaviour is not right for the dialect, you can
 * define a `__call__` method on the dialect that will get invoked to handle
 * the block processing.
 */
Markdown.prototype.processBlock = function processBlock( block, next ) {
  var cbs = this.dialect.block,
      ord = cbs.__order__;

  if ( "__call__" in cbs ) {
    return cbs.__call__.call(this, block, next);
  }

  for ( var i = 0; i < ord.length; i++ ) {
    //D:this.debug( "Testing", ord[i] );
    var res = cbs[ ord[i] ].call( this, block, next );
    if ( res ) {
      //D:this.debug("  matched");
      if ( !isArray(res) || ( res.length > 0 && !( isArray(res[0]) ) ) )
        this.debug(ord[i], "didn't return a proper array");
      //D:this.debug( "" );
      return res;
    }
  }

  // Uhoh! no match! Should we throw an error?
  return [];
};

Markdown.prototype.processInline = function processInline( block ) {
  return this.dialect.inline.__call__.call( this, String( block ) );
};

/**
 *  Markdown#toTree( source ) -> JsonML
 *  - source (String): markdown source to parse
 *
 *  Parse `source` into a JsonML tree representing the markdown document.
 **/
// custom_tree means set this.tree to `custom_tree` and restore old value on return
Markdown.prototype.toTree = function toTree( source, custom_root ) {
  var blocks = source instanceof Array ? source : this.split_blocks( source );

  // Make tree a member variable so its easier to mess with in extensions
  var old_tree = this.tree;
  try {
    this.tree = custom_root || this.tree || [ "markdown" ];

    blocks:
    while ( blocks.length ) {
      var b = this.processBlock( blocks.shift(), blocks );

      // Reference blocks and the like won't return any content
      if ( !b.length ) continue blocks;

      this.tree.push.apply( this.tree, b );
    }
    return this.tree;
  }
  finally {
    if ( custom_root ) {
      this.tree = old_tree;
    }
  }
};

// Noop by default
Markdown.prototype.debug = function () {
  var args = Array.prototype.slice.call( arguments);
  args.unshift(this.debug_indent);
  if ( typeof print !== "undefined" )
      print.apply( print, args );
  if ( typeof console !== "undefined" && typeof console.log !== "undefined" )
      console.log.apply( null, args );
}

Markdown.prototype.loop_re_over_block = function( re, block, cb ) {
  // Dont use /g regexps with this
  var m,
      b = block.valueOf();

  while ( b.length && (m = re.exec(b) ) != null ) {
    b = b.substr( m[0].length );
    cb.call(this, m);
  }
  return b;
};

/**
 * Markdown.dialects
 *
 * Namespace of built-in dialects.
 **/
Markdown.dialects = {};

/**
 * Markdown.dialects.Gruber
 *
 * The default dialect that follows the rules set out by John Gruber's
 * markdown.pl as closely as possible. Well actually we follow the behaviour of
 * that script which in some places is not exactly what the syntax web page
 * says.
 **/
Markdown.dialects.Gruber = {
  block: {
    atxHeader: function atxHeader( block, next ) {
      var m = block.match( /^(#{1,6})\s*(.*?)\s*#*\s*(?:\n|$)/ );

      if ( !m ) return undefined;

      var header = [ "header", { level: m[ 1 ].length } ];
      Array.prototype.push.apply(header, this.processInline(m[ 2 ]));

      if ( m[0].length < block.length )
        next.unshift( mk_block( block.substr( m[0].length ), block.trailing, block.lineNumber + 2 ) );

      return [ header ];
    },

    setextHeader: function setextHeader( block, next ) {
      var m = block.match( /^(.*)\n([-=])\2\2+(?:\n|$)/ );

      if ( !m ) return undefined;

      var level = ( m[ 2 ] === "=" ) ? 1 : 2;
      var header = [ "header", { level : level }, m[ 1 ] ];

      if ( m[0].length < block.length )
        next.unshift( mk_block( block.substr( m[0].length ), block.trailing, block.lineNumber + 2 ) );

      return [ header ];
    },

    code: function code( block, next ) {
      // |    Foo
      // |bar
      // should be a code block followed by a paragraph. Fun
      //
      // There might also be adjacent code block to merge.

      var ret = [],
          re = /^(?: {0,3}\t| {4})(.*)\n?/,
          lines;

      // 4 spaces + content
      if ( !block.match( re ) ) return undefined;

      block_search:
      do {
        // Now pull out the rest of the lines
        var b = this.loop_re_over_block(
                  re, block.valueOf(), function( m ) { ret.push( m[1] ); } );

        if ( b.length ) {
          // Case alluded to in first comment. push it back on as a new block
          next.unshift( mk_block(b, block.trailing) );
          break block_search;
        }
        else if ( next.length ) {
          // Check the next block - it might be code too
          if ( !next[0].match( re ) ) break block_search;

          // Pull how how many blanks lines follow - minus two to account for .join
          ret.push ( block.trailing.replace(/[^\n]/g, "").substring(2) );

          block = next.shift();
        }
        else {
          break block_search;
        }
      } while ( true );

      return [ [ "code_block", ret.join("\n") ] ];
    },

    horizRule: function horizRule( block, next ) {
      // this needs to find any hr in the block to handle abutting blocks
      var m = block.match( /^(?:([\s\S]*?)\n)?[ \t]*([-_*])(?:[ \t]*\2){2,}[ \t]*(?:\n([\s\S]*))?$/ );

      if ( !m ) {
        return undefined;
      }

      var jsonml = [ [ "hr" ] ];

      // if there's a leading abutting block, process it
      if ( m[ 1 ] ) {
        jsonml.unshift.apply( jsonml, this.processBlock( m[ 1 ], [] ) );
      }

      // if there's a trailing abutting block, stick it into next
      if ( m[ 3 ] ) {
        next.unshift( mk_block( m[ 3 ] ) );
      }

      return jsonml;
    },

    // There are two types of lists. Tight and loose. Tight lists have no whitespace
    // between the items (and result in text just in the <li>) and loose lists,
    // which have an empty line between list items, resulting in (one or more)
    // paragraphs inside the <li>.
    //
    // There are all sorts weird edge cases about the original markdown.pl's
    // handling of lists:
    //
    // * Nested lists are supposed to be indented by four chars per level. But
    //   if they aren't, you can get a nested list by indenting by less than
    //   four so long as the indent doesn't match an indent of an existing list
    //   item in the 'nest stack'.
    //
    // * The type of the list (bullet or number) is controlled just by the
    //    first item at the indent. Subsequent changes are ignored unless they
    //    are for nested lists
    //
    lists: (function( ) {
      // Use a closure to hide a few variables.
      var any_list = "[*+-]|\\d+\\.",
          bullet_list = /[*+-]/,
          number_list = /\d+\./,
          // Capture leading indent as it matters for determining nested lists.
          is_list_re = new RegExp( "^( {0,3})(" + any_list + ")[ \t]+" ),
          indent_re = "(?: {0,3}\\t| {4})";

      // TODO: Cache this regexp for certain depths.
      // Create a regexp suitable for matching an li for a given stack depth
      function regex_for_depth( depth ) {

        return new RegExp(
          // m[1] = indent, m[2] = list_type
          "(?:^(" + indent_re + "{0," + depth + "} {0,3})(" + any_list + ")\\s+)|" +
          // m[3] = cont
          "(^" + indent_re + "{0," + (depth-1) + "}[ ]{0,4})"
        );
      }
      function expand_tab( input ) {
        return input.replace( / {0,3}\t/g, "    " );
      }

      // Add inline content `inline` to `li`. inline comes from processInline
      // so is an array of content
      function add(li, loose, inline, nl) {
        if ( loose ) {
          li.push( [ "para" ].concat(inline) );
          return;
        }
        // Hmmm, should this be any block level element or just paras?
        var add_to = li[li.length -1] instanceof Array && li[li.length - 1][0] == "para"
                   ? li[li.length -1]
                   : li;

        // If there is already some content in this list, add the new line in
        if ( nl && li.length > 1 ) inline.unshift(nl);

        for ( var i = 0; i < inline.length; i++ ) {
          var what = inline[i],
              is_str = typeof what == "string";
          if ( is_str && add_to.length > 1 && typeof add_to[add_to.length-1] == "string" ) {
            add_to[ add_to.length-1 ] += what;
          }
          else {
            add_to.push( what );
          }
        }
      }

      // contained means have an indent greater than the current one. On
      // *every* line in the block
      function get_contained_blocks( depth, blocks ) {

        var re = new RegExp( "^(" + indent_re + "{" + depth + "}.*?\\n?)*$" ),
            replace = new RegExp("^" + indent_re + "{" + depth + "}", "gm"),
            ret = [];

        while ( blocks.length > 0 ) {
          if ( re.exec( blocks[0] ) ) {
            var b = blocks.shift(),
                // Now remove that indent
                x = b.replace( replace, "");

            ret.push( mk_block( x, b.trailing, b.lineNumber ) );
          }
          else {
            break;
          }
        }
        return ret;
      }

      // passed to stack.forEach to turn list items up the stack into paras
      function paragraphify(s, i, stack) {
        var list = s.list;
        var last_li = list[list.length-1];

        if ( last_li[1] instanceof Array && last_li[1][0] == "para" ) {
          return;
        }
        if ( i + 1 == stack.length ) {
          // Last stack frame
          // Keep the same array, but replace the contents
          last_li.push( ["para"].concat( last_li.splice(1, last_li.length - 1) ) );
        }
        else {
          var sublist = last_li.pop();
          last_li.push( ["para"].concat( last_li.splice(1, last_li.length - 1) ), sublist );
        }
      }

      // The matcher function
      return function( block, next ) {
        var m = block.match( is_list_re );
        if ( !m ) return undefined;

        function make_list( m ) {
          var list = bullet_list.exec( m[2] )
                   ? ["bulletlist"]
                   : ["numberlist"];

          stack.push( { list: list, indent: m[1] } );
          return list;
        }


        var stack = [], // Stack of lists for nesting.
            list = make_list( m ),
            last_li,
            loose = false,
            ret = [ stack[0].list ],
            i;

        // Loop to search over block looking for inner block elements and loose lists
        loose_search:
        while ( true ) {
          // Split into lines preserving new lines at end of line
          var lines = block.split( /(?=\n)/ );

          // We have to grab all lines for a li and call processInline on them
          // once as there are some inline things that can span lines.
          var li_accumulate = "";

          // Loop over the lines in this block looking for tight lists.
          tight_search:
          for ( var line_no = 0; line_no < lines.length; line_no++ ) {
            var nl = "",
                l = lines[line_no].replace(/^\n/, function(n) { nl = n; return ""; });

            // TODO: really should cache this
            var line_re = regex_for_depth( stack.length );

            m = l.match( line_re );
            //print( "line:", uneval(l), "\nline match:", uneval(m) );

            // We have a list item
            if ( m[1] !== undefined ) {
              // Process the previous list item, if any
              if ( li_accumulate.length ) {
                add( last_li, loose, this.processInline( li_accumulate ), nl );
                // Loose mode will have been dealt with. Reset it
                loose = false;
                li_accumulate = "";
              }

              m[1] = expand_tab( m[1] );
              var wanted_depth = Math.floor(m[1].length/4)+1;
              //print( "want:", wanted_depth, "stack:", stack.length);
              if ( wanted_depth > stack.length ) {
                // Deep enough for a nested list outright
                //print ( "new nested list" );
                list = make_list( m );
                last_li.push( list );
                last_li = list[1] = [ "listitem" ];
              }
              else {
                // We aren't deep enough to be strictly a new level. This is
                // where Md.pl goes nuts. If the indent matches a level in the
                // stack, put it there, else put it one deeper then the
                // wanted_depth deserves.
                var found = false;
                for ( i = 0; i < stack.length; i++ ) {
                  if ( stack[ i ].indent != m[1] ) continue;
                  list = stack[ i ].list;
                  stack.splice( i+1, stack.length - (i+1) );
                  found = true;
                  break;
                }

                if (!found) {
                  //print("not found. l:", uneval(l));
                  wanted_depth++;
                  if ( wanted_depth <= stack.length ) {
                    stack.splice(wanted_depth, stack.length - wanted_depth);
                    //print("Desired depth now", wanted_depth, "stack:", stack.length);
                    list = stack[wanted_depth-1].list;
                    //print("list:", uneval(list) );
                  }
                  else {
                    //print ("made new stack for messy indent");
                    list = make_list(m);
                    last_li.push(list);
                  }
                }

                //print( uneval(list), "last", list === stack[stack.length-1].list );
                last_li = [ "listitem" ];
                list.push(last_li);
              } // end depth of shenegains
              nl = "";
            }

            // Add content
            if ( l.length > m[0].length ) {
              li_accumulate += nl + l.substr( m[0].length );
            }
          } // tight_search

          if ( li_accumulate.length ) {
            add( last_li, loose, this.processInline( li_accumulate ), nl );
            // Loose mode will have been dealt with. Reset it
            loose = false;
            li_accumulate = "";
          }

          // Look at the next block - we might have a loose list. Or an extra
          // paragraph for the current li
          var contained = get_contained_blocks( stack.length, next );

          // Deal with code blocks or properly nested lists
          if ( contained.length > 0 ) {
            // Make sure all listitems up the stack are paragraphs
            forEach( stack, paragraphify, this);

            last_li.push.apply( last_li, this.toTree( contained, [] ) );
          }

          var next_block = next[0] && next[0].valueOf() || "";

          if ( next_block.match(is_list_re) || next_block.match( /^ / ) ) {
            block = next.shift();

            // Check for an HR following a list: features/lists/hr_abutting
            var hr = this.dialect.block.horizRule( block, next );

            if ( hr ) {
              ret.push.apply(ret, hr);
              break;
            }

            // Make sure all listitems up the stack are paragraphs
            forEach( stack, paragraphify, this);

            loose = true;
            continue loose_search;
          }
          break;
        } // loose_search

        return ret;
      };
    })(),

    blockquote: function blockquote( block, next ) {
      if ( !block.match( /^>/m ) )
        return undefined;

      var jsonml = [];

      // separate out the leading abutting block, if any. I.e. in this case:
      //
      //  a
      //  > b
      //
      if ( block[ 0 ] != ">" ) {
        var lines = block.split( /\n/ ),
            prev = [],
            line_no = block.lineNumber;

        // keep shifting lines until you find a crotchet
        while ( lines.length && lines[ 0 ][ 0 ] != ">" ) {
            prev.push( lines.shift() );
            line_no++;
        }

        var abutting = mk_block( prev.join( "\n" ), "\n", block.lineNumber );
        jsonml.push.apply( jsonml, this.processBlock( abutting, [] ) );
        // reassemble new block of just block quotes!
        block = mk_block( lines.join( "\n" ), block.trailing, line_no );
      }


      // if the next block is also a blockquote merge it in
      while ( next.length && next[ 0 ][ 0 ] == ">" ) {
        var b = next.shift();
        block = mk_block( block + block.trailing + b, b.trailing, block.lineNumber );
      }

      // Strip off the leading "> " and re-process as a block.
      var input = block.replace( /^> ?/gm, "" ),
          old_tree = this.tree,
          processedBlock = this.toTree( input, [ "blockquote" ] ),
          attr = extract_attr( processedBlock );

      // If any link references were found get rid of them
      if ( attr && attr.references ) {
        delete attr.references;
        // And then remove the attribute object if it's empty
        if ( isEmpty( attr ) ) {
          processedBlock.splice( 1, 1 );
        }
      }

      jsonml.push( processedBlock );
      return jsonml;
    },

    referenceDefn: function referenceDefn( block, next) {
      var re = /^\s*\[(.*?)\]:\s*(\S+)(?:\s+(?:(['"])(.*?)\3|\((.*?)\)))?\n?/;
      // interesting matches are [ , ref_id, url, , title, title ]

      if ( !block.match(re) )
        return undefined;

      // make an attribute node if it doesn't exist
      if ( !extract_attr( this.tree ) ) {
        this.tree.splice( 1, 0, {} );
      }

      var attrs = extract_attr( this.tree );

      // make a references hash if it doesn't exist
      if ( attrs.references === undefined ) {
        attrs.references = {};
      }

      var b = this.loop_re_over_block(re, block, function( m ) {

        if ( m[2] && m[2][0] == "<" && m[2][m[2].length-1] == ">" )
          m[2] = m[2].substring( 1, m[2].length - 1 );

        var ref = attrs.references[ m[1].toLowerCase() ] = {
          href: m[2]
        };

        if ( m[4] !== undefined )
          ref.title = m[4];
        else if ( m[5] !== undefined )
          ref.title = m[5];

      } );

      if ( b.length )
        next.unshift( mk_block( b, block.trailing ) );

      return [];
    },

    para: function para( block, next ) {
      // everything's a para!
      return [ ["para"].concat( this.processInline( block ) ) ];
    }
  }
};

Markdown.dialects.Gruber.inline = {

    __oneElement__: function oneElement( text, patterns_or_re, previous_nodes ) {
      var m,
          res,
          lastIndex = 0;

      patterns_or_re = patterns_or_re || this.dialect.inline.__patterns__;
      var re = new RegExp( "([\\s\\S]*?)(" + (patterns_or_re.source || patterns_or_re) + ")" );

      m = re.exec( text );
      if (!m) {
        // Just boring text
        return [ text.length, text ];
      }
      else if ( m[1] ) {
        // Some un-interesting text matched. Return that first
        return [ m[1].length, m[1] ];
      }

      var res;
      if ( m[2] in this.dialect.inline ) {
        res = this.dialect.inline[ m[2] ].call(
                  this,
                  text.substr( m.index ), m, previous_nodes || [] );
      }
      // Default for now to make dev easier. just slurp special and output it.
      res = res || [ m[2].length, m[2] ];
      return res;
    },

    __call__: function inline( text, patterns ) {

      var out = [],
          res;

      function add(x) {
        //D:self.debug("  adding output", uneval(x));
        if ( typeof x == "string" && typeof out[out.length-1] == "string" )
          out[ out.length-1 ] += x;
        else
          out.push(x);
      }

      while ( text.length > 0 ) {
        res = this.dialect.inline.__oneElement__.call(this, text, patterns, out );
        text = text.substr( res.shift() );
        forEach(res, add )
      }

      return out;
    },

    // These characters are intersting elsewhere, so have rules for them so that
    // chunks of plain text blocks don't include them
    "]": function () {},
    "}": function () {},

    __escape__ : /^\\[\\`\*_{}\[\]()#\+.!\-]/,

    "\\": function escaped( text ) {
      // [ length of input processed, node/children to add... ]
      // Only esacape: \ ` * _ { } [ ] ( ) # * + - . !
      if ( this.dialect.inline.__escape__.exec( text ) )
        return [ 2, text.charAt( 1 ) ];
      else
        // Not an esacpe
        return [ 1, "\\" ];
    },

    "![": function image( text ) {

      // Unlike images, alt text is plain text only. no other elements are
      // allowed in there

      // ![Alt text](/path/to/img.jpg "Optional title")
      //      1          2            3       4         <--- captures
      var m = text.match( /^!\[(.*?)\][ \t]*\([ \t]*([^")]*?)(?:[ \t]+(["'])(.*?)\3)?[ \t]*\)/ );

      if ( m ) {
        if ( m[2] && m[2][0] == "<" && m[2][m[2].length-1] == ">" )
          m[2] = m[2].substring( 1, m[2].length - 1 );

        m[2] = this.dialect.inline.__call__.call( this, m[2], /\\/ )[0];

        var attrs = { alt: m[1], href: m[2] || "" };
        if ( m[4] !== undefined)
          attrs.title = m[4];

        return [ m[0].length, [ "img", attrs ] ];
      }

      // ![Alt text][id]
      m = text.match( /^!\[(.*?)\][ \t]*\[(.*?)\]/ );

      if ( m ) {
        // We can't check if the reference is known here as it likely wont be
        // found till after. Check it in md tree->hmtl tree conversion
        return [ m[0].length, [ "img_ref", { alt: m[1], ref: m[2].toLowerCase(), original: m[0] } ] ];
      }

      // Just consume the '!['
      return [ 2, "![" ];
    },

    "[": function link( text ) {

      var orig = String(text);
      // Inline content is possible inside `link text`
      var res = Markdown.DialectHelpers.inline_until_char.call( this, text.substr(1), "]" );

      // No closing ']' found. Just consume the [
      if ( !res ) return [ 1, "[" ];

      var consumed = 1 + res[ 0 ],
          children = res[ 1 ],
          link,
          attrs;

      // At this point the first [...] has been parsed. See what follows to find
      // out which kind of link we are (reference or direct url)
      text = text.substr( consumed );

      // [link text](/path/to/img.jpg "Optional title")
      //                 1            2       3         <--- captures
      // This will capture up to the last paren in the block. We then pull
      // back based on if there a matching ones in the url
      //    ([here](/url/(test))
      // The parens have to be balanced
      var m = text.match( /^\s*\([ \t]*([^"']*)(?:[ \t]+(["'])(.*?)\2)?[ \t]*\)/ );
      if ( m ) {
        var url = m[1];
        consumed += m[0].length;

        if ( url && url[0] == "<" && url[url.length-1] == ">" )
          url = url.substring( 1, url.length - 1 );

        // If there is a title we don't have to worry about parens in the url
        if ( !m[3] ) {
          var open_parens = 1; // One open that isn't in the capture
          for ( var len = 0; len < url.length; len++ ) {
            switch ( url[len] ) {
            case "(":
              open_parens++;
              break;
            case ")":
              if ( --open_parens == 0) {
                consumed -= url.length - len;
                url = url.substring(0, len);
              }
              break;
            }
          }
        }

        // Process escapes only
        url = this.dialect.inline.__call__.call( this, url, /\\/ )[0];

        attrs = { href: url || "" };
        if ( m[3] !== undefined)
          attrs.title = m[3];

        link = [ "link", attrs ].concat( children );
        return [ consumed, link ];
      }

      // [Alt text][id]
      // [Alt text] [id]
      m = text.match( /^\s*\[(.*?)\]/ );

      if ( m ) {

        consumed += m[ 0 ].length;

        // [links][] uses links as its reference
        attrs = { ref: ( m[ 1 ] || String(children) ).toLowerCase(),  original: orig.substr( 0, consumed ) };

        link = [ "link_ref", attrs ].concat( children );

        // We can't check if the reference is known here as it likely wont be
        // found till after. Check it in md tree->hmtl tree conversion.
        // Store the original so that conversion can revert if the ref isn't found.
        return [ consumed, link ];
      }

      // [id]
      // Only if id is plain (no formatting.)
      if ( children.length == 1 && typeof children[0] == "string" ) {

        attrs = { ref: children[0].toLowerCase(),  original: orig.substr( 0, consumed ) };
        link = [ "link_ref", attrs, children[0] ];
        return [ consumed, link ];
      }

      // Just consume the "["
      return [ 1, "[" ];
    },


    "<": function autoLink( text ) {
      var m;

      if ( ( m = text.match( /^<(?:((https?|ftp|mailto):[^>]+)|(.*?@.*?\.[a-zA-Z]+))>/ ) ) != null ) {
        if ( m[3] ) {
          return [ m[0].length, [ "link", { href: "mailto:" + m[3] }, m[3] ] ];

        }
        else if ( m[2] == "mailto" ) {
          return [ m[0].length, [ "link", { href: m[1] }, m[1].substr("mailto:".length ) ] ];
        }
        else
          return [ m[0].length, [ "link", { href: m[1] }, m[1] ] ];
      }

      return [ 1, "<" ];
    },

    "`": function inlineCode( text ) {
      // Inline code block. as many backticks as you like to start it
      // Always skip over the opening ticks.
      var m = text.match( /(`+)(([\s\S]*?)\1)/ );

      if ( m && m[2] )
        return [ m[1].length + m[2].length, [ "inlinecode", m[3] ] ];
      else {
        // TODO: No matching end code found - warn!
        return [ 1, "`" ];
      }
    },

    "  \n": function lineBreak( text ) {
      return [ 3, [ "linebreak" ] ];
    }

};

// Meta Helper/generator method for em and strong handling
function strong_em( tag, md ) {

  var state_slot = tag + "_state",
      other_slot = tag == "strong" ? "em_state" : "strong_state";

  function CloseTag(len) {
    this.len_after = len;
    this.name = "close_" + md;
  }

  return function ( text, orig_match ) {

    if ( this[state_slot][0] == md ) {
      // Most recent em is of this type
      //D:this.debug("closing", md);
      this[state_slot].shift();

      // "Consume" everything to go back to the recrusion in the else-block below
      return[ text.length, new CloseTag(text.length-md.length) ];
    }
    else {
      // Store a clone of the em/strong states
      var other = this[other_slot].slice(),
          state = this[state_slot].slice();

      this[state_slot].unshift(md);

      //D:this.debug_indent += "  ";

      // Recurse
      var res = this.processInline( text.substr( md.length ) );
      //D:this.debug_indent = this.debug_indent.substr(2);

      var last = res[res.length - 1];

      //D:this.debug("processInline from", tag + ": ", uneval( res ) );

      var check = this[state_slot].shift();
      if ( last instanceof CloseTag ) {
        res.pop();
        // We matched! Huzzah.
        var consumed = text.length - last.len_after;
        return [ consumed, [ tag ].concat(res) ];
      }
      else {
        // Restore the state of the other kind. We might have mistakenly closed it.
        this[other_slot] = other;
        this[state_slot] = state;

        // We can't reuse the processed result as it could have wrong parsing contexts in it.
        return [ md.length, md ];
      }
    }
  }; // End returned function
}

Markdown.dialects.Gruber.inline["**"] = strong_em("strong", "**");
Markdown.dialects.Gruber.inline["__"] = strong_em("strong", "__");
Markdown.dialects.Gruber.inline["*"]  = strong_em("em", "*");
Markdown.dialects.Gruber.inline["_"]  = strong_em("em", "_");


// Build default order from insertion order.
Markdown.buildBlockOrder = function(d) {
  var ord = [];
  for ( var i in d ) {
    if ( i == "__order__" || i == "__call__" ) continue;
    ord.push( i );
  }
  d.__order__ = ord;
};

// Build patterns for inline matcher
Markdown.buildInlinePatterns = function(d) {
  var patterns = [];

  for ( var i in d ) {
    // __foo__ is reserved and not a pattern
    if ( i.match( /^__.*__$/) ) continue;
    var l = i.replace( /([\\.*+?|()\[\]{}])/g, "\\$1" )
             .replace( /\n/, "\\n" );
    patterns.push( i.length == 1 ? l : "(?:" + l + ")" );
  }

  patterns = patterns.join("|");
  d.__patterns__ = patterns;
  //print("patterns:", uneval( patterns ) );

  var fn = d.__call__;
  d.__call__ = function(text, pattern) {
    if ( pattern != undefined ) {
      return fn.call(this, text, pattern);
    }
    else
    {
      return fn.call(this, text, patterns);
    }
  };
};

Markdown.DialectHelpers = {};
Markdown.DialectHelpers.inline_until_char = function( text, want ) {
  var consumed = 0,
      nodes = [];

  while ( true ) {
    if ( text.charAt( consumed ) == want ) {
      // Found the character we were looking for
      consumed++;
      return [ consumed, nodes ];
    }

    if ( consumed >= text.length ) {
      // No closing char found. Abort.
      return null;
    }

    var res = this.dialect.inline.__oneElement__.call(this, text.substr( consumed ) );
    consumed += res[ 0 ];
    // Add any returned nodes.
    nodes.push.apply( nodes, res.slice( 1 ) );
  }
}

// Helper function to make sub-classing a dialect easier
Markdown.subclassDialect = function( d ) {
  function Block() {}
  Block.prototype = d.block;
  function Inline() {}
  Inline.prototype = d.inline;

  return { block: new Block(), inline: new Inline() };
};

Markdown.buildBlockOrder ( Markdown.dialects.Gruber.block );
Markdown.buildInlinePatterns( Markdown.dialects.Gruber.inline );

Markdown.dialects.Maruku = Markdown.subclassDialect( Markdown.dialects.Gruber );

Markdown.dialects.Maruku.processMetaHash = function processMetaHash( meta_string ) {
  var meta = split_meta_hash( meta_string ),
      attr = {};

  for ( var i = 0; i < meta.length; ++i ) {
    // id: #foo
    if ( /^#/.test( meta[ i ] ) ) {
      attr.id = meta[ i ].substring( 1 );
    }
    // class: .foo
    else if ( /^\./.test( meta[ i ] ) ) {
      // if class already exists, append the new one
      if ( attr["class"] ) {
        attr["class"] = attr["class"] + meta[ i ].replace( /./, " " );
      }
      else {
        attr["class"] = meta[ i ].substring( 1 );
      }
    }
    // attribute: foo=bar
    else if ( /\=/.test( meta[ i ] ) ) {
      var s = meta[ i ].split( /\=/ );
      attr[ s[ 0 ] ] = s[ 1 ];
    }
  }

  return attr;
}

function split_meta_hash( meta_string ) {
  var meta = meta_string.split( "" ),
      parts = [ "" ],
      in_quotes = false;

  while ( meta.length ) {
    var letter = meta.shift();
    switch ( letter ) {
      case " " :
        // if we're in a quoted section, keep it
        if ( in_quotes ) {
          parts[ parts.length - 1 ] += letter;
        }
        // otherwise make a new part
        else {
          parts.push( "" );
        }
        break;
      case "'" :
      case '"' :
        // reverse the quotes and move straight on
        in_quotes = !in_quotes;
        break;
      case "\\" :
        // shift off the next letter to be used straight away.
        // it was escaped so we'll keep it whatever it is
        letter = meta.shift();
      default :
        parts[ parts.length - 1 ] += letter;
        break;
    }
  }

  return parts;
}

Markdown.dialects.Maruku.block.document_meta = function document_meta( block, next ) {
  // we're only interested in the first block
  if ( block.lineNumber > 1 ) return undefined;

  // document_meta blocks consist of one or more lines of `Key: Value\n`
  if ( ! block.match( /^(?:\w+:.*\n)*\w+:.*$/ ) ) return undefined;

  // make an attribute node if it doesn't exist
  if ( !extract_attr( this.tree ) ) {
    this.tree.splice( 1, 0, {} );
  }

  var pairs = block.split( /\n/ );
  for ( p in pairs ) {
    var m = pairs[ p ].match( /(\w+):\s*(.*)$/ ),
        key = m[ 1 ].toLowerCase(),
        value = m[ 2 ];

    this.tree[ 1 ][ key ] = value;
  }

  // document_meta produces no content!
  return [];
};

Markdown.dialects.Maruku.block.block_meta = function block_meta( block, next ) {
  // check if the last line of the block is an meta hash
  var m = block.match( /(^|\n) {0,3}\{:\s*((?:\\\}|[^\}])*)\s*\}$/ );
  if ( !m ) return undefined;

  // process the meta hash
  var attr = this.dialect.processMetaHash( m[ 2 ] );

  var hash;

  // if we matched ^ then we need to apply meta to the previous block
  if ( m[ 1 ] === "" ) {
    var node = this.tree[ this.tree.length - 1 ];
    hash = extract_attr( node );

    // if the node is a string (rather than JsonML), bail
    if ( typeof node === "string" ) return undefined;

    // create the attribute hash if it doesn't exist
    if ( !hash ) {
      hash = {};
      node.splice( 1, 0, hash );
    }

    // add the attributes in
    for ( a in attr ) {
      hash[ a ] = attr[ a ];
    }

    // return nothing so the meta hash is removed
    return [];
  }

  // pull the meta hash off the block and process what's left
  var b = block.replace( /\n.*$/, "" ),
      result = this.processBlock( b, [] );

  // get or make the attributes hash
  hash = extract_attr( result[ 0 ] );
  if ( !hash ) {
    hash = {};
    result[ 0 ].splice( 1, 0, hash );
  }

  // attach the attributes to the block
  for ( a in attr ) {
    hash[ a ] = attr[ a ];
  }

  return result;
};

Markdown.dialects.Maruku.block.definition_list = function definition_list( block, next ) {
  // one or more terms followed by one or more definitions, in a single block
  var tight = /^((?:[^\s:].*\n)+):\s+([\s\S]+)$/,
      list = [ "dl" ],
      i, m;

  // see if we're dealing with a tight or loose block
  if ( ( m = block.match( tight ) ) ) {
    // pull subsequent tight DL blocks out of `next`
    var blocks = [ block ];
    while ( next.length && tight.exec( next[ 0 ] ) ) {
      blocks.push( next.shift() );
    }

    for ( var b = 0; b < blocks.length; ++b ) {
      var m = blocks[ b ].match( tight ),
          terms = m[ 1 ].replace( /\n$/, "" ).split( /\n/ ),
          defns = m[ 2 ].split( /\n:\s+/ );

      // print( uneval( m ) );

      for ( i = 0; i < terms.length; ++i ) {
        list.push( [ "dt", terms[ i ] ] );
      }

      for ( i = 0; i < defns.length; ++i ) {
        // run inline processing over the definition
        list.push( [ "dd" ].concat( this.processInline( defns[ i ].replace( /(\n)\s+/, "$1" ) ) ) );
      }
    }
  }
  else {
    return undefined;
  }

  return [ list ];
};

// splits on unescaped instances of @ch. If @ch is not a character the result
// can be unpredictable

Markdown.dialects.Maruku.block.table = function table (block, next) {

    var _split_on_unescaped = function(s, ch) {
        ch = ch || '\\s';
        if (ch.match(/^[\\|\[\]{}?*.+^$]$/)) { ch = '\\' + ch; }
        var res = [ ],
            r = new RegExp('^((?:\\\\.|[^\\\\' + ch + '])*)' + ch + '(.*)'),
            m;
        while(m = s.match(r)) {
            res.push(m[1]);
            s = m[2];
        }
        res.push(s);
        return res;
    }

    var leading_pipe = /^ {0,3}\|(.+)\n {0,3}\|\s*([\-:]+[\-| :]*)\n((?:\s*\|.*(?:\n|$))*)(?=\n|$)/,
        // find at least an unescaped pipe in each line
        no_leading_pipe = /^ {0,3}(\S(?:\\.|[^\\|])*\|.*)\n {0,3}([\-:]+\s*\|[\-| :]*)\n((?:(?:\\.|[^\\|])*\|.*(?:\n|$))*)(?=\n|$)/,
        i, m;
    if (m = block.match(leading_pipe)) {
        // remove leading pipes in contents
        // (header and horizontal rule already have the leading pipe left out)
        m[3] = m[3].replace(/^\s*\|/gm, '');
    } else if (! ( m = block.match(no_leading_pipe))) {
        return undefined;
    }

    var table = [ "table", [ "thead", [ "tr" ] ], [ "tbody" ] ];

    // remove trailing pipes, then split on pipes
    // (no escaped pipes are allowed in horizontal rule)
    m[2] = m[2].replace(/\|\s*$/, '').split('|');

    // process alignment
    var html_attrs = [ ];
    forEach (m[2], function (s) {
        if (s.match(/^\s*-+:\s*$/))       html_attrs.push({align: "right"});
        else if (s.match(/^\s*:-+\s*$/))  html_attrs.push({align: "left"});
        else if (s.match(/^\s*:-+:\s*$/)) html_attrs.push({align: "center"});
        else                              html_attrs.push({});
    });

    // now for the header, avoid escaped pipes
    m[1] = _split_on_unescaped(m[1].replace(/\|\s*$/, ''), '|');
    for (i = 0; i < m[1].length; i++) {
        table[1][1].push(['th', html_attrs[i] || {}].concat(
            this.processInline(m[1][i].trim())));
    }

    // now for body contents
    forEach (m[3].replace(/\|\s*$/mg, '').split('\n'), function (row) {
        var html_row = ['tr'];
        row = _split_on_unescaped(row, '|');
        for (i = 0; i < row.length; i++) {
            html_row.push(['td', html_attrs[i] || {}].concat(this.processInline(row[i].trim())));
        }
        table[2].push(html_row);
    }, this);

    return [table];
}

Markdown.dialects.Maruku.inline[ "{:" ] = function inline_meta( text, matches, out ) {
  if ( !out.length ) {
    return [ 2, "{:" ];
  }

  // get the preceeding element
  var before = out[ out.length - 1 ];

  if ( typeof before === "string" ) {
    return [ 2, "{:" ];
  }

  // match a meta hash
  var m = text.match( /^\{:\s*((?:\\\}|[^\}])*)\s*\}/ );

  // no match, false alarm
  if ( !m ) {
    return [ 2, "{:" ];
  }

  // attach the attributes to the preceeding element
  var meta = this.dialect.processMetaHash( m[ 1 ] ),
      attr = extract_attr( before );

  if ( !attr ) {
    attr = {};
    before.splice( 1, 0, attr );
  }

  for ( var k in meta ) {
    attr[ k ] = meta[ k ];
  }

  // cut out the string and replace it with nothing
  return [ m[ 0 ].length, "" ];
};

Markdown.dialects.Maruku.inline.__escape__ = /^\\[\\`\*_{}\[\]()#\+.!\-|:]/;

Markdown.buildBlockOrder ( Markdown.dialects.Maruku.block );
Markdown.buildInlinePatterns( Markdown.dialects.Maruku.inline );

var isArray = Array.isArray || function(obj) {
  return Object.prototype.toString.call(obj) == "[object Array]";
};

var forEach;
// Don't mess with Array.prototype. Its not friendly
if ( Array.prototype.forEach ) {
  forEach = function( arr, cb, thisp ) {
    return arr.forEach( cb, thisp );
  };
}
else {
  forEach = function(arr, cb, thisp) {
    for (var i = 0; i < arr.length; i++) {
      cb.call(thisp || arr, arr[i], i, arr);
    }
  }
}

var isEmpty = function( obj ) {
  for ( var key in obj ) {
    if ( hasOwnProperty.call( obj, key ) ) {
      return false;
    }
  }

  return true;
}

function extract_attr( jsonml ) {
  return isArray(jsonml)
      && jsonml.length > 1
      && typeof jsonml[ 1 ] === "object"
      && !( isArray(jsonml[ 1 ]) )
      ? jsonml[ 1 ]
      : undefined;
}



/**
 *  renderJsonML( jsonml[, options] ) -> String
 *  - jsonml (Array): JsonML array to render to XML
 *  - options (Object): options
 *
 *  Converts the given JsonML into well-formed XML.
 *
 *  The options currently understood are:
 *
 *  - root (Boolean): wether or not the root node should be included in the
 *    output, or just its children. The default `false` is to not include the
 *    root itself.
 */
expose.renderJsonML = function( jsonml, options ) {
  options = options || {};
  // include the root element in the rendered output?
  options.root = options.root || false;

  var content = [];

  if ( options.root ) {
    content.push( render_tree( jsonml ) );
  }
  else {
    jsonml.shift(); // get rid of the tag
    if ( jsonml.length && typeof jsonml[ 0 ] === "object" && !( jsonml[ 0 ] instanceof Array ) ) {
      jsonml.shift(); // get rid of the attributes
    }

    while ( jsonml.length ) {
      content.push( render_tree( jsonml.shift() ) );
    }
  }

  return content.join( "\n\n" );
};

function escapeHTML( text ) {
  return text.replace( /&/g, "&amp;" )
             .replace( /</g, "&lt;" )
             .replace( />/g, "&gt;" )
             .replace( /"/g, "&quot;" )
             .replace( /'/g, "&#39;" );
}

function render_tree( jsonml ) {
  // basic case
  if ( typeof jsonml === "string" ) {
    return escapeHTML( jsonml );
  }

  var tag = jsonml.shift(),
      attributes = {},
      content = [];

  if ( jsonml.length && typeof jsonml[ 0 ] === "object" && !( jsonml[ 0 ] instanceof Array ) ) {
    attributes = jsonml.shift();
  }

  while ( jsonml.length ) {
    content.push( render_tree( jsonml.shift() ) );
  }

  var tag_attrs = "";
  for ( var a in attributes ) {
    tag_attrs += " " + a + '="' + escapeHTML( attributes[ a ] ) + '"';
  }

  // be careful about adding whitespace here for inline elements
  if ( tag == "img" || tag == "br" || tag == "hr" ) {
    return "<"+ tag + tag_attrs + "/>";
  }
  else {
    return "<"+ tag + tag_attrs + ">" + content.join( "" ) + "</" + tag + ">";
  }
}

function convert_tree_to_html( tree, references, options ) {
  var i;
  options = options || {};

  // shallow clone
  var jsonml = tree.slice( 0 );

  if ( typeof options.preprocessTreeNode === "function" ) {
      jsonml = options.preprocessTreeNode(jsonml, references);
  }

  // Clone attributes if they exist
  var attrs = extract_attr( jsonml );
  if ( attrs ) {
    jsonml[ 1 ] = {};
    for ( i in attrs ) {
      jsonml[ 1 ][ i ] = attrs[ i ];
    }
    attrs = jsonml[ 1 ];
  }

  // basic case
  if ( typeof jsonml === "string" ) {
    return jsonml;
  }

  // convert this node
  switch ( jsonml[ 0 ] ) {
    case "header":
      jsonml[ 0 ] = "h" + jsonml[ 1 ].level;
      delete jsonml[ 1 ].level;
      break;
    case "bulletlist":
      jsonml[ 0 ] = "ul";
      break;
    case "numberlist":
      jsonml[ 0 ] = "ol";
      break;
    case "listitem":
      jsonml[ 0 ] = "li";
      break;
    case "para":
      jsonml[ 0 ] = "p";
      break;
    case "markdown":
      jsonml[ 0 ] = "html";
      if ( attrs ) delete attrs.references;
      break;
    case "code_block":
      jsonml[ 0 ] = "pre";
      i = attrs ? 2 : 1;
      var code = [ "code" ];
      code.push.apply( code, jsonml.splice( i, jsonml.length - i ) );
      jsonml[ i ] = code;
      break;
    case "inlinecode":
      jsonml[ 0 ] = "code";
      break;
    case "img":
      jsonml[ 1 ].src = jsonml[ 1 ].href;
      delete jsonml[ 1 ].href;
      break;
    case "linebreak":
      jsonml[ 0 ] = "br";
    break;
    case "link":
      jsonml[ 0 ] = "a";
      break;
    case "link_ref":
      jsonml[ 0 ] = "a";

      // grab this ref and clean up the attribute node
      var ref = references[ attrs.ref ];

      // if the reference exists, make the link
      if ( ref ) {
        delete attrs.ref;

        // add in the href and title, if present
        attrs.href = ref.href;
        if ( ref.title ) {
          attrs.title = ref.title;
        }

        // get rid of the unneeded original text
        delete attrs.original;
      }
      // the reference doesn't exist, so revert to plain text
      else {
        return attrs.original;
      }
      break;
    case "img_ref":
      jsonml[ 0 ] = "img";

      // grab this ref and clean up the attribute node
      var ref = references[ attrs.ref ];

      // if the reference exists, make the link
      if ( ref ) {
        delete attrs.ref;

        // add in the href and title, if present
        attrs.src = ref.href;
        if ( ref.title ) {
          attrs.title = ref.title;
        }

        // get rid of the unneeded original text
        delete attrs.original;
      }
      // the reference doesn't exist, so revert to plain text
      else {
        return attrs.original;
      }
      break;
  }

  // convert all the children
  i = 1;

  // deal with the attribute node, if it exists
  if ( attrs ) {
    // if there are keys, skip over it
    for ( var key in jsonml[ 1 ] ) {
        i = 2;
        break;
    }
    // if there aren't, remove it
    if ( i === 1 ) {
      jsonml.splice( i, 1 );
    }
  }

  for ( ; i < jsonml.length; ++i ) {
    jsonml[ i ] = convert_tree_to_html( jsonml[ i ], references, options );
  }

  return jsonml;
}


// merges adjacent text nodes into a single node
function merge_text_nodes( jsonml ) {
  // skip the tag name and attribute hash
  var i = extract_attr( jsonml ) ? 2 : 1;

  while ( i < jsonml.length ) {
    // if it's a string check the next item too
    if ( typeof jsonml[ i ] === "string" ) {
      if ( i + 1 < jsonml.length && typeof jsonml[ i + 1 ] === "string" ) {
        // merge the second string into the first and remove it
        jsonml[ i ] += jsonml.splice( i + 1, 1 )[ 0 ];
      }
      else {
        ++i;
      }
    }
    // if it's not a string recurse
    else {
      merge_text_nodes( jsonml[ i ] );
      ++i;
    }
  }
}

} )( (function() {
  if ( typeof exports === "undefined" ) {
    window.markdown = {};
    return window.markdown;
  }
  else {
    return exports;
  }
} )() );

},{"util":21}],18:[function(require,module,exports){
// shim for using process in browser

var process = module.exports = {};

process.nextTick = (function () {
    var canSetImmediate = typeof window !== 'undefined'
    && window.setImmediate;
    var canMutationObserver = typeof window !== 'undefined'
    && window.MutationObserver;
    var canPost = typeof window !== 'undefined'
    && window.postMessage && window.addEventListener
    ;

    if (canSetImmediate) {
        return function (f) { return window.setImmediate(f) };
    }

    var queue = [];

    if (canMutationObserver) {
        var hiddenDiv = document.createElement("div");
        var observer = new MutationObserver(function () {
            var queueList = queue.slice();
            queue.length = 0;
            queueList.forEach(function (fn) {
                fn();
            });
        });

        observer.observe(hiddenDiv, { attributes: true });

        return function nextTick(fn) {
            if (!queue.length) {
                hiddenDiv.setAttribute('yes', 'no');
            }
            queue.push(fn);
        };
    }

    if (canPost) {
        window.addEventListener('message', function (ev) {
            var source = ev.source;
            if ((source === window || source === null) && ev.data === 'process-tick') {
                ev.stopPropagation();
                if (queue.length > 0) {
                    var fn = queue.shift();
                    fn();
                }
            }
        }, true);

        return function nextTick(fn) {
            queue.push(fn);
            window.postMessage('process-tick', '*');
        };
    }

    return function nextTick(fn) {
        setTimeout(fn, 0);
    };
})();

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};

},{}],19:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],20:[function(require,module,exports){
module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
},{}],21:[function(require,module,exports){
(function (process,global){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./support/isBuffer":20,"_process":18,"inherits":19}]},{},[1])

